import { Toaster, toast } from 'react-hot-toast';
import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  FiMenu, FiX, FiLogOut, FiPlus, FiUsers, FiFolder, FiCheckCircle,
  FiClock, FiAlertCircle, FiUser, FiMail, FiLock, FiGrid, FiBriefcase,
  FiSettings, FiArrowRight, FiArrowLeft, FiRotateCcw, FiPhone, FiCalendar,
  FiEdit2, FiTrash2, FiMessageCircle, FiDollarSign, FiTrendingUp, FiRefreshCw,
  FiImage, FiUpload, FiUserPlus, FiUserCheck, FiUserX, FiFolderPlus, FiDownload,
  FiFileText, FiEye, FiDownloadCloud, FiCheck, FiAlertTriangle 
} from "react-icons/fi";

import JSZip from "jszip";
import { saveAs } from "file-saver";
import WhatsAppSender from './WhatsAppSender';
import styles from './App.module.css';

const base_url = "https://digitalmarketingwala.co.in/task-api";
// const base_url = "http://localhost/task-api";
axios.defaults.withCredentials = true;
const ClientDetailsModal = ({ client, isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex items-center justify-center min-h-screen px-4 pt-4 pb-20 text-center sm:block sm:p-0">
        {/* Backdrop */}
        <div className="fixed inset-0 bg-black opacity-50 transition-opacity" onClick={onClose}></div>

        {/* Center modal */}
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">&#8203;</span>
        
        {/* Modal */}
        <div className="relative inline-block align-bottom bg-white rounded-lg shadow-xl transform transition-all sm:my-8 sm:align-middle max-w-4xl w-full">
          {/* Sticky Header */}
          <div className="sticky top-0 z-10 bg-white border-b rounded-t-lg px-6 py-4 flex justify-between items-center">
            <h3 className="text-lg font-semibold text-gray-900">Client Details: {client.name}</h3>
            <button
              onClick={onClose}
              className="text-gray-400 hover:text-gray-600 focus:outline-none"
            >
              <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          {/* Scrollable Content Area */}
          <div className="overflow-y-auto max-h-[calc(90vh-120px)] px-6 py-4">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Email */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Email</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.email ? (
                    <a href={`mailto:${client.email}`} className="text-blue-600 hover:underline">
                      {client.email}
                    </a>
                  ) : '-'}
                </p>
              </div>

              {/* Phone */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Phone</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.phone ? (
                    <a href={`tel:${client.phone}`} className="hover:text-blue-600">
                      {client.phone}
                    </a>
                  ) : '-'}
                </p>
              </div>

              {/* Website */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Website</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.website ? (
                    <a
                      href={client.website.startsWith('http') ? client.website : `https://${client.website}`}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 hover:underline"
                    >
                      {client.website}
                    </a>
                  ) : '-'}
                </p>
              </div>

              {/* Address */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Address</label>
                <p className="mt-1 text-sm text-gray-900 break-words" title={client.address}>
                  {client.address || '-'}
                </p>
              </div>

              {/* Plan */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Plan</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.plan_name || (client.plan_id ? `Plan ${client.plan_id}` : '-')}
                </p>
              </div>

              {/* Price */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Price</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.plan_price ? `₹${parseFloat(client.plan_price).toLocaleString()}` : '-'}
                </p>
              </div>

              {/* Duration */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Duration</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.plan_duration || '-'}
                </p>
              </div>

              {/* Payment Date */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Payment Date</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.payment_date ? new Date(client.payment_date).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  }) : '-'}
                </p>
              </div>

              {/* Status */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Status</label>
                <p className="mt-1">
                  <span className={`px-2 py-1 text-xs font-semibold rounded-full ${client.status === 'active' ? 'bg-green-100 text-green-800' :
                    client.status === 'inactive' ? 'bg-red-100 text-red-800' :
                      'bg-yellow-100 text-yellow-800'
                    }`}>
                    {client.status || 'lead'}
                  </span>
                </p>
              </div>

              {/* Source */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Source</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.source ? (
                    <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                      {client.source}
                    </span>
                  ) : '-'}
                </p>
              </div>

              {/* Created Date */}
              <div>
                <label className="text-xs font-medium text-gray-500 uppercase">Created</label>
                <p className="mt-1 text-sm text-gray-900">
                  {client.created_at ? new Date(client.created_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'short',
                    day: 'numeric'
                  }) : '-'}
                </p>
              </div>
            </div>
          </div>

          {/* Sticky Footer */}
          <div className="sticky bottom-0 z-10 bg-gray-50 border-t rounded-b-lg px-6 py-4 flex justify-end">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};
function App() {
  const [employeeTaskStats, setEmployeeTaskStats] = useState([]);
const [dashboardSummary, setDashboardSummary] = useState({
    total_tasks: 0,
    today_tasks: 0,
    completed_tasks: 0
});
const [weeklyTrends, setWeeklyTrends] = useState([]);
const [projectDistribution, setProjectDistribution] = useState([]);
const [statsDateRange, setStatsDateRange] = useState('all');

  const [activeStatusTab, setActiveStatusTab] = useState('new'); // 'new', 'urgent', or 'old'

  const [salaries, setSalaries] = useState([]);
  const [showAddSalary, setShowAddSalary] = useState(false);
  const [showSalaryDetails, setShowSalaryDetails] = useState(false);
  const [selectedSalary, setSelectedSalary] = useState(null);
  const [salaryForm, setSalaryForm] = useState({
    employee_id: "",
    base_salary: 0,
    allowances: 0,
    bonus: 0,
    deductions: 0,
    net_salary: 0,
    salary_month: new Date().toISOString().slice(0, 7), // YYYY-MM
    payment_date: new Date().toISOString().split('T')[0],
    payment_method: "bank_transfer",
    status: "pending", // pending, paid, cancelled
    notes: ""
  });

  const [salaryComponents, setSalaryComponents] = useState({
    hra: 0, // House Rent Allowance
    da: 0,  // Dearness Allowance
    ta: 0,  // Travel Allowance
    medical: 0,
    other_allowances: 0,
    pf_deduction: 0, // Provident Fund
    professional_tax: 0,
    income_tax: 0,
    other_deductions: 0
  });
  const [selectedClient, setSelectedClient] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleViewMore = (client) => {
    setSelectedClient(client);
    setIsModalOpen(true);
  };
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const [modalImages, setModalImages] = useState([]);
  const [selectedEmployee, setSelectedEmployee] = useState(null);
  const [assignedClients, setAssignedClients] = useState([]);
  const [editingEmployee, setEditingEmployee] = useState(null);
  // Add these state variables at the top of your component with your other useState declarations
  const [campaigns, setCampaigns] = useState([]);
  const [newCampaign, setNewCampaign] = useState({
    client_id: '',
    status: 'draft'
  });
  const [selectedCampaigns, setSelectedCampaigns] = useState([]);
  const [selectedCampaignForWhatsApp, setSelectedCampaignForWhatsApp] = useState(null);

  // Add these functions in your component before the return statement

  // Fetch campaigns
  const fetchCampaigns = async () => {
    try {
      const response = await fetch(`${base_url}/campaigns/get_campaigns.php`, {
        headers: {
          'Content-Type': 'application/json',
        }
      });
      const data = await response.json();
      if (data.success) {
        setCampaigns(data.data);
      }
    } catch (error) {
      console.error('Error fetching campaigns:', error);
      toast.error('Failed to fetch campaigns');
    }
  };

  // Add new campaign - Only sends client_id and status
  const addCampaign = async () => {
    if (!newCampaign.client_id) {
      toast.error('Please select a client');
      return;
    }

    try {
      const response = await fetch(`${base_url}/campaigns/create_campaign.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          client_id: newCampaign.client_id,
          status: newCampaign.status
        })
      });

      const data = await response.json();
      if (data.success) {
        setCampaigns([data.data, ...campaigns]);
        setNewCampaign({
          client_id: '',
          status: 'draft'
        });
        toast.success('Campaign added successfully');
      } else {
        toast.error(data.message || 'Failed to add campaign');
      }
    } catch (error) {
      console.error('Error adding campaign:', error);
      toast.error('Error adding campaign');
    }
  };

  // Update campaign status
  const handleCampaignStatusChange = async (campaignId, newStatus) => {
    try {
      const response = await fetch(`${base_url}/campaigns/update_campaign_status.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ 
          campaign_id: campaignId, 
          status: newStatus 
        })
      });

      const data = await response.json();
      if (data.success) {
        setCampaigns(campaigns.map(campaign => 
          campaign.id === campaignId 
            ? { ...campaign, status: newStatus }
            : campaign
        ));
        toast.success('Campaign status updated');
      } else {
        toast.error(data.message || 'Failed to update status');
      }
    } catch (error) {
      console.error('Error updating campaign status:', error);
      toast.error('Error updating campaign status');
    }
  };

  // Handle campaign selection
  const handleCampaignSelect = (campaignId, isChecked) => {
    if (isChecked) {
      setSelectedCampaigns([...selectedCampaigns, campaignId]);
    } else {
      setSelectedCampaigns(selectedCampaigns.filter(id => id !== campaignId));
    }
  };

  // Handle select all campaigns
  const handleSelectAllCampaigns = (isChecked) => {
    if (isChecked) {
      setSelectedCampaigns(campaigns.map(c => c.id));
    } else {
      setSelectedCampaigns([]);
    }
  };

  // Delete campaign
  const handleDeleteCampaign = async (campaignId) => {
    if (!window.confirm('Are you sure you want to delete this campaign?')) return;

    try {
      const response = await fetch(`${base_url}/campaigns/delete_campaign.php`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ campaign_id: campaignId })
      });

      const data = await response.json();
      if (data.success) {
        setCampaigns(campaigns.filter(c => c.id !== campaignId));
        setSelectedCampaigns(selectedCampaigns.filter(id => id !== campaignId));
        toast.success('Campaign deleted successfully');
      } else {
        toast.error(data.message || 'Failed to delete campaign');
      }
    } catch (error) {
      console.error('Error deleting campaign:', error);
      toast.error('Error deleting campaign');
    }
  };


  const [showWhatsAppSender, setShowWhatsAppSender] = useState(false);
  const [selectedPosterForWhatsApp, setSelectedPosterForWhatsApp] = useState(null);
  const [whatsappLogs, setWhatsappLogs] = useState([]);
  // ALL HOOKS MUST BE AT THE TOP LEVEL - BEFORE ANY CONDITIONAL RETURNS
  const [authType, setAuthType] = useState(null);
  const [activePage, setActivePage] = useState("dashboard");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [plans, setPlans] = useState([]);
  const [showPlanModal, setShowPlanModal] = useState(false);
  const [editingPlan, setEditingPlan] = useState(null);
  const [planForm, setPlanForm] = useState({
    name: "",
    price: "",
    duration: "monthly",
    status: "active"
  });
  const [tasks, setTasks] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [projects, setProjects] = useState([]);
  const [employeeTasks, setEmployeeTasks] = useState([]);
  const [employeeName, setEmployeeName] = useState("");

  const [selectedClientForAssignment, setSelectedClientForAssignment] = useState(null);
  const [showEmployeeModal, setShowEmployeeModal] = useState(false);
  const [selectedEmployeeId, setSelectedEmployeeId] = useState('');

  // Sales state
  const [leads, setLeads] = useState([]);
  const [leadId, setLeadId] = useState("");
  const [selectedLead, setSelectedLead] = useState(null);

  const [selectedTaskForDetails, setSelectedTaskForDetails] = useState(null);
  const [showLeadDetails, setShowLeadDetails] = useState(false);

  const [followups, setFollowups] = useState([]);
  const [showAddLead, setShowAddLead] = useState(false);
  const [showAddFollowup, setShowAddFollowup] = useState(false);
  const [editingFollowup, setEditingFollowup] = useState(null);

  // Form states
  const [title, setTitle] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [projectId, setProjectId] = useState("");
  const [newEmployee, setNewEmployee] = useState("");
  const [newProject, setNewProject] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [employeeCode, setEmployeeCode] = useState("");
  const [loginMode, setLoginMode] = useState("admin");
  const [clients, setClients] = useState([]);
  const [posters, setPosters] = useState([]);

  // Employee section states
  const [selectedTaskDetails, setSelectedTaskDetails] = useState(null);
  const [showClientDetails, setShowClientDetails] = useState(false);
  const [clientPosters, setClientPosters] = useState([]);
  const [loading, setLoading] = useState(false);

  // Lead/Client relationship states
  const [showConvertLeadModal, setShowConvertLeadModal] = useState(false);
  const [selectedLeadForConversion, setSelectedLeadForConversion] = useState(null);
  const [conversionForm, setConversionForm] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    website: "",
    address: "",
    conversion_plan_id: "",
    conversion_payment_date: "",
    create_invoice: false
  });
  const [editingClient, setEditingClient] = useState(null);
  const [newClient, setNewClient] = useState({
    name: "",
    company: "",
    email: "",
    phone: "",
    website: "",
    address: "",
    status: "lead",
    source: "",
    notes: "",
    logo: null,
    new_plan_id: "",
    new_payment_date: "",
    attachment: null,
  });

  // Add these state variables to your component
  const [newPoster, setNewPoster] = useState({
    client_id: "",
    title: "",
    description: "",
    image: null
  });

  const [editingPoster, setEditingPoster] = useState(null);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editFormData, setEditFormData] = useState({
    id: null,
    client_id: "",
    campaign_id: "",
    title: "",
    description: "",
    assigned_to: "",
    scheduled_date: "",
    image: null
  });
  
  const handleAssignEmployee = async () => {
    if (!selectedClientForAssignment || !selectedEmployeeId) {
      toast.error('Please select an employee');
      return;
    }
    if (!activeStatusTab) {
      toast.error('Please select a status (New, Urgent, or Old)');
      return;
    }
    try {
      // You'll need to create this endpoint
      const response = await axios.post(`${base_url}/assign_employee_to_client.php`, {
	client_status: activeStatusTab,
        client_id: selectedClientForAssignment.id,
        employee_id: selectedEmployeeId
      });

      if (response.data.success) {
        // Refresh clients list
        fetchClients();
        setShowEmployeeModal(false);
        setSelectedClientForAssignment(null);
        setSelectedEmployeeId('');
        toast.success('Employee assigned successfully');
      } else {
        toast.error(response.data.message || 'Failed to assign employee');
      }
    } catch (error) {
      console.error('Error assigning employee:', error);
      toast.error('Error assigning employee');
    }
  };
  
  // Handle edit button click
  const handleEditPoster = (poster) => {
    setEditingPoster(poster);
    setEditFormData({
      id: poster.id,
      client_id: poster.client_id,
      campaign_id: poster.campaign_id || "",
      title: poster.title,
      description: poster.description || "",
      assigned_to: poster.assigned_to || "",
      scheduled_date: poster.scheduled_date ? poster.scheduled_date.split(' ')[0] : "",
      image: null
    });
    setShowEditModal(true);
  };

  // Handle edit form input changes
  const handleEditInputChange = (e) => {
    const { name, value } = e.target;
    setEditFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  // Handle edit form file change
  const handleEditFileChange = (e) => {
    setEditFormData(prev => ({
      ...prev,
      image: e.target.files[0]
    }));
  };

  // Handle update poster
  const handleUpdatePoster = async () => {
    if (!editFormData.client_id || !editFormData.title) {
      toast.error('Please select a client and enter a title');
      return;
    }

    try {
      // First update poster details
      const updateData = {
        id: editFormData.id,
        client_id: editFormData.client_id,
        campaign_id: editFormData.campaign_id || null,
        title: editFormData.title,
        description: editFormData.description || null,
        assigned_to: editFormData.assigned_to || null,
        scheduled_date: editFormData.scheduled_date || null
      };

      const response = await axios.post(`${base_url}/posters/update_poster.php`, updateData);

      if (response.data.success) {
        // If a new image was selected, upload it
        if (editFormData.image) {
          const formData = new FormData();
          formData.append('poster_id', editFormData.id);
          formData.append('poster_image', editFormData.image);

          await axios.post(`${base_url}/posters/upload_poster_image.php`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          });
        }

        // Close modal and refresh
        setShowEditModal(false);
        setEditingPoster(null);
        fetchPosters();
        toast.success('Poster updated successfully!');
      } else {
        throw new Error(response.data.error || 'Failed to update poster');
      }
    } catch (error) {
      console.error('Error updating poster:', error);
      toast.error('Failed to update poster: ' + (error.response?.data?.error || error.message));
    }
  };

  // Handle delete poster
  const handleDeletePoster = async (posterId) => {
    if (window.confirm('Are you sure you want to delete this poster?')) {
      try {
        const response = await axios.delete(`${base_url}/posters/delete_poster.php`, {
          data: { id: posterId }
        });

        if (response.data.success) {
          fetchPosters();
          toast.success('Poster deleted successfully!');
        } else {
          throw new Error(response.data.error || 'Failed to delete poster');
        }
      } catch (error) {
        toast.error('Failed to delete poster: ' + (error.response?.data?.error || error.message));
      }
    }
  };
  
  const openAttachmentModal = (attachments) => {
    let images = [];

    if (Array.isArray(attachments)) {
      images = attachments;
    }
    else if (typeof attachments === "string") {
      try {
        // check if JSON
        if (attachments.startsWith("[")) {
          images = JSON.parse(attachments);
        } else {
          images = attachments.split(",");
        }
      } catch {
        images = attachments.split(",");
      }
    }

    setModalImages(images);
    setShowAttachmentModal(true);
  };
  
  // Edit Modal Component
  const EditPosterModal = () => {
    if (!showEditModal) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-semibold">Edit Poster</h3>
              <button
                onClick={() => setShowEditModal(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ✕
              </button>
            </div>

            <div className="space-y-4">
              {/* Client Selection */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Client *
                </label>
                <select
                  name="client_id"
                  value={editFormData.client_id}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select Client</option>
                  {clients.map(c => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>

              {/* Campaign Selection (Optional) */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Campaign (Optional)
                </label>
                <select
                  name="campaign_id"
                  value={editFormData.campaign_id}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Campaign</option>
                  {campaigns?.map(c => (
                    <option key={c.id} value={c.id}>{c.name}</option>
                  ))}
                </select>
              </div>

              {/* Title */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Title *
                </label>
                <input
                  type="text"
                  name="title"
                  value={editFormData.title}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="Poster Title"
                  required
                />
              </div>

              {/* Description */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Description
                </label>
                <textarea
                  name="description"
                  value={editFormData.description}
                  onChange={handleEditInputChange}
                  rows="3"
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="Poster Description"
                />
              </div>

              {/* Assigned To */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Assign To (Optional)
                </label>
                <select
                  name="assigned_to"
                  value={editFormData.assigned_to}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Employee</option>
                  {employees?.map(e => (
                    <option key={e.id} value={e.id}>{e.name}</option>
                  ))}
                </select>
              </div>

              {/* Scheduled Date */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Scheduled Date (Optional)
                </label>
                <input
                  type="datetime-local"
                  name="scheduled_date"
                  value={editFormData.scheduled_date}
                  onChange={handleEditInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>

              {/* Current Image */}
              {editingPoster?.image_path && (
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Current Image
                  </label>
                  <div className="mt-1">
                    <img
                      src={`${base_url}/${editingPoster.image_path}`}
                      alt="Current poster"
                      className="h-32 w-auto object-cover rounded-lg border border-gray-200"
                    />
                  </div>
                </div>
              )}

              {/* New Image Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  {editingPoster?.image_path ? 'Change Image (Optional)' : 'Upload Image (Optional)'}
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleEditFileChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 file:mr-4 file:py-2 file:px-4 file:rounded-lg file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                {editFormData.image && (
                  <p className="mt-1 text-sm text-gray-500">
                    New image selected: {editFormData.image.name}
                  </p>
                )}
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={() => setShowEditModal(false)}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdatePoster}
                className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all"
              >
                Update Poster
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Lead form states
  const [leadForm, setLeadForm] = useState({
    name: "",
    payment_date: "",
    company: "",
    email: "",
    phone: "",
    status: "new",
    source: "website",
    notes: ""
  });

  // Followup form states
  const [followupForm, setFollowupForm] = useState({
    lead_id: "",
    followup_date: "",
    followup_time: "",
    status: "pending",
    notes: "",
    next_followup_date: "",
    next_followup_time: ""
  });
  
  const [images, setImages] = useState([]);
  const [imagePreviews, setImagePreviews] = useState([]);

  // Add these handler functions
  const handleImagesUpload = (e) => {
    const files = Array.from(e.target.files);

    // Filter only image files
    const imageFiles = files.filter(file => file.type.startsWith('image/'));

    setImages(prev => [...prev, ...imageFiles]);

    // Create previews for images
    const newPreviews = imageFiles.map(file => ({
      url: URL.createObjectURL(file),
      name: file.name
    }));

    setImagePreviews(prev => [...prev, ...newPreviews]);
  };

  const removeImage = (index) => {
    setImages(prev => prev.filter((_, i) => i !== index));
    setImagePreviews(prev => {
      // Clean up object URL
      if (prev[index]?.url) {
        URL.revokeObjectURL(prev[index].url);
      }
      return prev.filter((_, i) => i !== index);
    });
  };
  const checkForDuplicateClientIds = (clients) => {
  const seen = new Map();
  const duplicates = [];
  
  clients.forEach((client, index) => {
    if (seen.has(client.id)) {
      duplicates.push({
        id: client.id,
        firstIndex: seen.get(client.id),
        secondIndex: index,
        client1: seen.get(client.id),
        client2: client
      });
    } else {
      seen.set(client.id, index);
    }
  });
  
  if (duplicates.length > 0) {
    console.error('Duplicate client IDs found:', duplicates);
    console.error('This means your database has multiple clients with same ID');
  }
  
  return duplicates;
};
  useEffect(() => {
    if (clients && clients.length) {
    	checkForDuplicateClientIds(clients);
    }
    fetchClients();
    checkSession();
    fetchPlans(); // Add this line
    return () => {
      imagePreviews.forEach(preview => {
        if (preview?.url) {
          URL.revokeObjectURL(preview.url);
        }
      });
    };
  }, []);

  const checkSession = async () => {
    try {
      const adminRes = await axios.get(`${base_url}/auth/check_auth.php`);
      if (adminRes.data.auth) {
        setAuthType("admin");
        loadAll();
        return;
      }

      const empRes = await axios.get(`${base_url}/auth/employee_check.php`);
      if (empRes.data.auth) {
        setAuthType("employee");
        setEmployeeName(empRes.data.name);
        fetchEmployeeTasks();
        return;
      }

      setAuthType(false);
    } catch {
      setAuthType(false);
    }
  };

  const adminLogin = async () => {
    try {
      const res = await axios.post(
        `${base_url}/auth/login.php`,
        { email, password }
      );
      if (res.data.status) {
        setAuthType("admin");
        loadAll();
        toast.success('Admin login successful');
      } else {
        toast.error('Invalid Admin Login');
      }
    } catch (error) {
      toast.error('Login failed');
    }
  };

  const employeeLogin = async () => {
    try {
      const res = await axios.post(
        `${base_url}/auth/employee_login.php`,
        { code: employeeCode }
      );
      if (res.data.status) {
        const empRes = await axios.get(`${base_url}/auth/employee_check.php`);
        setAuthType("employee");
        setEmployeeName(empRes.data.name);
        fetchEmployeeTasks();
        toast.success('Employee login successful');
      } else {
        toast.error('Invalid Employee Code');
      }
    } catch (error) {
      toast.error('Login failed');
    }
  };

  const logout = async () => {
    await axios.get(`${base_url}/auth/logout.php`);
    await axios.get(`${base_url}/auth/employee_logout.php`);
    setAuthType(false);
    toast.success('Logged out successfully');
  };
  
  // Handle logo upload
  const handleLogoUpload = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const formData = new FormData();
      formData.append('logo', file);

      try {
        const response = await axios.post(`${base_url}/clients/upload_logo.php`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
        setNewClient({ ...newClient, logo: response.data.logo_path });
        toast.success('Logo uploaded successfully');
      } catch (error) {
        console.error('Error uploading logo:', error);
        toast.error('Error uploading logo');
      }
    }
  };
  
  // Add these state variables with your other useState declarations
  const [invoices, setInvoices] = useState([]);
  const [showAddInvoice, setShowAddInvoice] = useState(false);
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(false);
  const [selectedInvoice, setSelectedInvoice] = useState(null);
  const [invoiceItems, setInvoiceItems] = useState([]);
  const [invoiceForm, setInvoiceForm] = useState({
    client_id: "",
    invoice_number: "",
    invoice_date: new Date().toISOString().split('T')[0],
    due_date: "",
    subtotal: 0,
    tax_rate: 18,
    tax_amount: 0,
    discount_type: "percentage", // percentage or fixed
    discount_value: 0,
    discount_amount: 0,
    total: 0,
    status: "draft", // draft, sent, paid, overdue, cancelled
    notes: "",
    terms: "Payment due within 30 days"
  });

  const [newInvoiceItem, setNewInvoiceItem] = useState({
    description: "",
    quantity: 1,
    unit_price: 0,
    amount: 0
  });

  // Add this to your loadAll function
  const fetchInvoices = async () => {
    try {
      const res = await axios.get(`${base_url}/invoices/get_invoices.php`);
      if (res.data.success) {
        setInvoices(res.data.data);
      } else {
        setInvoices([]);
      }
    } catch (error) {
      console.error("Error fetching invoices:", error);
      setInvoices([]);
      toast.error('Failed to fetch invoices');
    }
  };
  const fetchInvoiceItems = async (file_path) => {
    console.log("file_path", file_path);

    if (!file_path) {
      toast.error("Invalid invoice file");
      return;
    }

    try {
      // Extract only file name
      const fileName = file_path.split('/').pop();

      const invoiceUrl = `${base_url}/invoices/${fileName}`;
      window.open(invoiceUrl, "_blank", "noopener,noreferrer");

    } catch (error) {
      console.error("Error fetching invoice:", error);
      toast.error("Failed to fetch invoice");
    }
  };
  const calculateInvoiceTotals = (items, taxRate, discountType, discountValue) => {
    const subtotal = items.reduce((sum, item) => sum + (parseFloat(item.amount) || 0), 0);
    const taxAmount = subtotal * (taxRate / 100);

    let discountAmount = 0;
    if (discountType === 'percentage') {
      discountAmount = subtotal * (discountValue / 100);
    } else {
      discountAmount = parseFloat(discountValue) || 0;
    }

    const total = subtotal + taxAmount - discountAmount;

    return { subtotal, taxAmount, discountAmount, total };
  };

  const handleAddInvoiceItem = () => {
    if (!newInvoiceItem.description || newInvoiceItem.quantity <= 0 || newInvoiceItem.unit_price <= 0) {
      toast.error('Please fill all item fields correctly');
      return;
    }

    const amount = newInvoiceItem.quantity * newInvoiceItem.unit_price;
    const item = { ...newInvoiceItem, amount };

    const updatedItems = [...invoiceItems, item];
    setInvoiceItems(updatedItems);

    // Recalculate totals
    const { subtotal, taxAmount, discountAmount, total } = calculateInvoiceTotals(
      updatedItems,
      invoiceForm.tax_rate,
      invoiceForm.discount_type,
      invoiceForm.discount_value
    );

    setInvoiceForm({
      ...invoiceForm,
      subtotal,
      tax_amount: taxAmount,
      discount_amount: discountAmount,
      total
    });

    // Reset new item form
    setNewInvoiceItem({
      description: "",
      quantity: 1,
      unit_price: 0,
      amount: 0
    });

    toast.success('Item added to invoice');
  };

  const handleRemoveInvoiceItem = (index) => {
    const updatedItems = invoiceItems.filter((_, i) => i !== index);
    setInvoiceItems(updatedItems);

    // Recalculate totals
    const { subtotal, taxAmount, discountAmount, total } = calculateInvoiceTotals(
      updatedItems,
      invoiceForm.tax_rate,
      invoiceForm.discount_type,
      invoiceForm.discount_value
    );

    setInvoiceForm({
      ...invoiceForm,
      subtotal,
      tax_amount: taxAmount,
      discount_amount: discountAmount,
      total
    });

    toast.success('Item removed');
  };

  const generateInvoiceNumber = () => {
    const date = new Date();
    const year = date.getFullYear().toString().slice(-2);
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const random = Math.floor(Math.random() * 1000).toString().padStart(3, '0');
    return `INV-${year}${month}-${random}`;
  };

  const handleAddInvoice = async () => {
    if (!invoiceForm.client_id) {
      toast.error('Please select a client');
      return;
    }

    if (invoiceItems.length === 0) {
      toast.error('Please add at least one item');
      return;
    }

    try {
      // Generate invoice number if not set
      if (!invoiceForm.invoice_number) {
        invoiceForm.invoice_number = generateInvoiceNumber();
      }

      // First create the invoice
      const invoiceData = {
        ...invoiceForm,
        items: invoiceItems
      };

      const response = await axios.post(`${base_url}/invoices/add_invoice.php`, invoiceData);

      if (response.data.success) {
        // Reset form
        setInvoiceForm({
          client_id: "",
          invoice_number: "",
          invoice_date: new Date().toISOString().split('T')[0],
          due_date: "",
          subtotal: 0,
          tax_rate: 18,
          tax_amount: 0,
          discount_type: "percentage",
          discount_value: 0,
          discount_amount: 0,
          total: 0,
          status: "draft",
          notes: "",
          terms: "Payment due within 30 days"
        });
        setInvoiceItems([]);
        setShowAddInvoice(false);

        // Refresh invoices list
        fetchInvoices();

        toast.success('Invoice created successfully!');
      } else {
        throw new Error(response.data.error || 'Failed to create invoice');
      }
    } catch (error) {
      console.error('Error creating invoice:', error);
      toast.error('Failed to create invoice: ' + (error.response?.data?.error || error.message));
    }
  };

  const handleUpdateInvoiceStatus = async (invoiceId, newStatus) => {
    try {
      const response = await axios.post(`${base_url}/invoices/update_invoice_status.php`, {
        id: invoiceId,
        status: newStatus
      });

      if (response.data.success) {
        fetchInvoices();
        toast.success('Invoice status updated successfully!');
      }
    } catch (error) {
      console.error('Error updating invoice status:', error);
      toast.error('Failed to update invoice status');
    }
  };

  const handleDeleteInvoice = async (invoiceId) => {
    if (window.confirm('Are you sure you want to delete this invoice?')) {
      try {
        const response = await axios.delete(`${base_url}/invoices/delete_invoice.php?id=${invoiceId}`);

        if (response.data.success) {
          fetchInvoices();
          toast.success('Invoice deleted successfully!');
        }
      } catch (error) {
        console.error('Error deleting invoice:', error);
        toast.error('Failed to delete invoice');
      }
    }
  };

  const getInvoiceStatusColor = (status) => {
    switch (status) {
      case 'draft': return 'bg-gray-100 text-gray-800';
      case 'sent': return 'bg-blue-100 text-blue-800';
      case 'paid': return 'bg-green-100 text-green-800';
      case 'overdue': return 'bg-red-100 text-red-800';
      case 'cancelled': return 'bg-yellow-100 text-yellow-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  // Add Invoice Modal Component
  const AddInvoiceModal = ({ show, onClose, clients, onSubmit }) => {
    if (!show) return null;

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Create New Invoice</h3>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX size={24} />
              </button>
            </div>

            <div className="space-y-6">
              {/* Invoice Header */}
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Client *
                  </label>
                  <select
                    value={invoiceForm.client_id}
                    onChange={(e) => setInvoiceForm({ ...invoiceForm, client_id: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                    required
                  >
                    <option value="">Select Client</option>
                    {clients.map(client => (
                      <option key={client.id} value={client.id}>
                        {client.name} {client.company ? `- ${client.company}` : ''}
                      </option>
                    ))}
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Invoice Number
                  </label>
                  <input
                    type="text"
                    value={invoiceForm.invoice_number}
                    onChange={(e) => setInvoiceForm({ ...invoiceForm, invoice_number: e.target.value })}
                    placeholder="Auto-generated if empty"
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Status
                  </label>
                  <select
                    value={invoiceForm.status}
                    onChange={(e) => setInvoiceForm({ ...invoiceForm, status: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  >
                    <option value="draft">Draft</option>
                    <option value="sent">Sent</option>
                    <option value="paid">Paid</option>
                  </select>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Invoice Date
                  </label>
                  <input
                    type="date"
                    value={invoiceForm.invoice_date}
                    onChange={(e) => setInvoiceForm({ ...invoiceForm, invoice_date: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Due Date
                  </label>
                  <input
                    type="date"
                    value={invoiceForm.due_date}
                    onChange={(e) => setInvoiceForm({ ...invoiceForm, due_date: e.target.value })}
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              {/* Invoice Items */}
              <div>
                <h4 className="text-lg font-semibold text-gray-800 mb-3">Invoice Items</h4>

                {/* Add Item Form */}
                <div className="grid grid-cols-12 gap-2 mb-3">
                  <div className="col-span-5">
                    <input
                      type="text"
                      placeholder="Description"
                      value={newInvoiceItem.description}
                      onChange={(e) => setNewInvoiceItem({ ...newInvoiceItem, description: e.target.value })}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <input
                      type="number"
                      placeholder="Qty"
                      value={newInvoiceItem.quantity}
                      onChange={(e) => {
                        const qty = parseFloat(e.target.value) || 0;
                        setNewInvoiceItem({
                          ...newInvoiceItem,
                          quantity: qty,
                          amount: qty * newInvoiceItem.unit_price
                        });
                      }}
                      min="1"
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <input
                      type="number"
                      placeholder="Price"
                      value={newInvoiceItem.unit_price}
                      onChange={(e) => {
                        const price = parseFloat(e.target.value) || 0;
                        setNewInvoiceItem({
                          ...newInvoiceItem,
                          unit_price: price,
                          amount: newInvoiceItem.quantity * price
                        });
                      }}
                      min="0"
                      step="0.01"
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                    />
                  </div>
                  <div className="col-span-2">
                    <input
                      type="number"
                      placeholder="Amount"
                      value={newInvoiceItem.amount}
                      readOnly
                      className="w-full px-3 py-2 bg-gray-50 border border-gray-200 rounded-lg"
                    />
                  </div>
                  <div className="col-span-1">
                    <button
                      onClick={handleAddInvoiceItem}
                      className="w-full px-3 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                    >
                      <FiPlus />
                    </button>
                  </div>
                </div>

                {/* Items List */}
                <div className="border border-gray-200 rounded-lg overflow-hidden">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Description</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Qty</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Unit Price</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Amount</th>
                        <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Action</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-200">
                      {invoiceItems.map((item, index) => (
                        <tr key={index}>
                          <td className="px-4 py-2 text-sm">{item.description}</td>
                          <td className="px-4 py-2 text-sm">{item.quantity}</td>
                          <td className="px-4 py-2 text-sm">₹{item.unit_price.toFixed(2)}</td>
                          <td className="px-4 py-2 text-sm">₹{item.amount.toFixed(2)}</td>
                          <td className="px-4 py-2">
                            <button
                              onClick={() => handleRemoveInvoiceItem(index)}
                              className="text-red-600 hover:text-red-800"
                            >
                              <FiTrash2 size={16} />
                            </button>
                          </td>
                        </tr>
                      ))}
                      {invoiceItems.length === 0 && (
                        <tr>
                          <td colSpan="5" className="px-4 py-8 text-center text-gray-500">
                            No items added yet
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Invoice Summary */}
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Notes
                  </label>
                  <textarea
                    value={invoiceForm.notes}
                    onChange={(e) => setInvoiceForm({ ...invoiceForm, notes: e.target.value })}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                    placeholder="Additional notes..."
                  />
                </div>

                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Subtotal:</span>
                    <span className="font-medium">₹{invoiceForm.subtotal.toFixed(2)}</span>
                  </div>

                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600">Tax (18%):</span>
                    <span className="font-medium">₹{invoiceForm.tax_amount.toFixed(2)}</span>
                  </div>

                  <div className="flex justify-between items-center">
                    <div className="flex items-center gap-2">
                      <span className="text-sm text-gray-600">Discount:</span>
                      <select
                        value={invoiceForm.discount_type}
                        onChange={(e) => {
                          const type = e.target.value;
                          setInvoiceForm({
                            ...invoiceForm,
                            discount_type: type,
                            discount_amount: type === 'percentage'
                              ? invoiceForm.subtotal * (invoiceForm.discount_value / 100)
                              : invoiceForm.discount_value
                          });
                        }}
                        className="text-xs border border-gray-200 rounded px-1 py-0.5"
                      >
                        <option value="percentage">%</option>
                        <option value="fixed">₹</option>
                      </select>
                      <input
                        type="number"
                        value={invoiceForm.discount_value}
                        onChange={(e) => {
                          const value = parseFloat(e.target.value) || 0;
                          const discountAmount = invoiceForm.discount_type === 'percentage'
                            ? invoiceForm.subtotal * (value / 100)
                            : value;
                          setInvoiceForm({
                            ...invoiceForm,
                            discount_value: value,
                            discount_amount: discountAmount,
                            total: invoiceForm.subtotal + invoiceForm.tax_amount - discountAmount
                          });
                        }}
                        min="0"
                        step="0.01"
                        className="w-20 text-xs border border-gray-200 rounded px-1 py-0.5"
                      />
                    </div>
                    <span className="font-medium text-red-600">-₹{invoiceForm.discount_amount.toFixed(2)}</span>
                  </div>

                  <div className="border-t border-gray-200 pt-2 flex justify-between items-center">
                    <span className="text-base font-semibold text-gray-800">Total:</span>
                    <span className="text-xl font-bold text-blue-600">₹{invoiceForm.total.toFixed(2)}</span>
                  </div>
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Terms & Conditions
                </label>
                <textarea
                  value={invoiceForm.terms}
                  onChange={(e) => setInvoiceForm({ ...invoiceForm, terms: e.target.value })}
                  rows="2"
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                onClick={onClose}
                className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={handleAddInvoice}
                className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700"
              >
                Create Invoice
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  };

  // Invoice Details Modal
  const InvoiceDetailsModal = ({ show, onClose, invoice, items, clients, onStatusUpdate }) => {
    if (!show || !invoice) return null;

    const client = clients.find(c => c.id == invoice.client_id);

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
          <div className="p-6">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-xl font-bold text-gray-800">Invoice Details</h3>
              <button
                onClick={onClose}
                className="text-gray-500 hover:text-gray-700"
              >
                <FiX size={24} />
              </button>
            </div>

            <div className="space-y-6">
              {/* Invoice Header */}
              <div className="flex justify-between items-start">
                <div>
                  <h4 className="text-2xl font-bold text-gray-800">{invoice.invoice_number}</h4>
                  <p className="text-sm text-gray-500">
                    Date: {new Date(invoice.invoice_date).toLocaleDateString()}
                  </p>
                  <p className="text-sm text-gray-500">
                    Due Date: {new Date(invoice.due_date).toLocaleDateString()}
                  </p>
                </div>
                <div>
                  <span className={`px-3 py-1 text-sm rounded-full ${getInvoiceStatusColor(invoice.status)}`}>
                    {invoice.status.toUpperCase()}
                  </span>
                </div>
              </div>

              {/* Client Info */}
              {client && (
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h5 className="font-semibold text-gray-700 mb-2">Client Information</h5>
                  <p className="font-medium">{client.name}</p>
                  {client.company && <p className="text-sm text-gray-600">{client.company}</p>}
                  {client.email && <p className="text-sm text-gray-600">{client.email}</p>}
                  {client.phone && <p className="text-sm text-gray-600">{client.phone}</p>}
                  {client.address && <p className="text-sm text-gray-600">{client.address}</p>}
                </div>
              )}

              {/* Items */}
              <div>
                <h5 className="font-semibold text-gray-700 mb-2">Items</h5>
                <table className="min-w-full divide-y divide-gray-200 border border-gray-200 rounded-lg">
                  <thead className="bg-gray-50">
                    <tr>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Description</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Qty</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Unit Price</th>
                      <th className="px-4 py-2 text-left text-xs font-medium text-gray-500">Amount</th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200">
                    {items.map((item, index) => (
                      <tr key={index}>
                        <td className="px-4 py-2">{item.description}</td>
                        <td className="px-4 py-2">{item.quantity}</td>
                        <td className="px-4 py-2">₹{parseFloat(item.unit_price).toFixed(2)}</td>
                        <td className="px-4 py-2">₹{parseFloat(item.amount).toFixed(2)}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              {/* Summary */}
              <div className="flex justify-end">
                <div className="w-64 space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">Subtotal:</span>
                    <span>₹{parseFloat(invoice.subtotal).toFixed(2)}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Tax (18%):</span>
                    <span>₹{parseFloat(invoice.tax_amount).toFixed(2)}</span>
                  </div>
                  {parseFloat(invoice.discount_amount) > 0 && (
                    <div className="flex justify-between text-red-600">
                      <span>Discount:</span>
                      <span>-₹{parseFloat(invoice.discount_amount).toFixed(2)}</span>
                    </div>
                  )}
                  <div className="border-t border-gray-200 pt-2 flex justify-between font-bold">
                    <span>Total:</span>
                    <span className="text-blue-600">₹{parseFloat(invoice.total).toFixed(2)}</span>
                  </div>
                </div>
              </div>

              {/* Notes */}
              {invoice.notes && (
                <div>
                  <h5 className="font-semibold text-gray-700 mb-1">Notes</h5>
                  <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded">{invoice.notes}</p>
                </div>
              )}

              {/* Terms */}
              {invoice.terms && (
                <div>
                  <h5 className="font-semibold text-gray-700 mb-1">Terms & Conditions</h5>
                  <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded">{invoice.terms}</p>
                </div>
              )}

              {/* Status Update */}
              <div className="flex justify-end gap-3">
                {invoice.status !== 'paid' && (
                  <button
                    onClick={() => onStatusUpdate(invoice.id, 'paid')}
                    className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
                  >
                    Mark as Paid
                  </button>
                )}
                {invoice.status === 'draft' && (
                  <button
                    onClick={() => onStatusUpdate(invoice.id, 'sent')}
                    className="px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700"
                  >
                    Mark as Sent
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  
  // Fetch assigned clients for an employee
  const fetchAssignedClients = async (employeeId) => {
    try {
      const response = await axios.get(`${base_url}/get_employee_clients.php?employee_id=${employeeId}`);
      setAssignedClients(Array.isArray(response.data) ? response.data : []);
    } catch (error) {
      console.error('Error fetching assigned clients:', error);
      setAssignedClients([]);
      toast.error('Failed to fetch assigned clients');
    }
  };

  // Handle employee click to show details
  const handleEmployeeClick = (emp) => {
    setSelectedEmployee(emp);
    fetchAssignedClients(emp.id);
  };
const downloadInvoice = async (client_id) => {
  // Use your proxy endpoint
  window.open(`https://digitalmarketingwala.co.in/task-api/proxy-invoice.php?client_id=${client_id}`, '_blank');
};
  // Open edit employee modal
  const openEditEmployeeModal = (emp) => {
    setEditingEmployee(emp);
  };

  // Handle delete employee
  const handleDeleteEmployee = async (employeeId) => {
    if (window.confirm('Are you sure you want to delete this employee?')) {
      try {
        const response = await axios.delete(`${base_url}/delete_employee.php?id=${employeeId}`);
        if (response.data.success) {
          // Refresh employees list
          fetchEmployees();
          // Clear selected employee if deleted
          if (selectedEmployee?.id === employeeId) {
            setSelectedEmployee(null);
            setAssignedClients([]);
          }
          toast.success('Employee deleted successfully');
        } else {
          toast.error('Failed to delete employee');
        }
      } catch (error) {
        console.error('Error deleting employee:', error);
        toast.error('Error deleting employee');
      }
    }
  };
  
  // Helper function to get file extension
  const getFileExtension = (filename) => {
    return filename.substring(filename.lastIndexOf('.'));
  };
  const downloadFile = (filePath, filename) => {
    if (!filePath) return;

    const link = document.createElement('a');
    link.href = `${base_url}/${filePath}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  const downloadAttachmentFiles  = (attachments) => {

    const url = `${base_url}/download-attachments.php?files=${encodeURIComponent(attachments)}`;

    window.open(url, "_blank");

  };
  // Open edit modal
  const openEditModal = (client) => {
    setEditingClient(client);
  };

  const handleUpdateClient = async (updatedClient) => {
    // console.log(images, imagePreviews);
    // return;
    try {

      let logoPath = updatedClient.logo || '';
      let attachmentPaths = [];

      // Upload logo
      if (updatedClient.logoFile) {

        const logoData = new FormData();
        logoData.append("logo", updatedClient.logoFile);
        logoData.append("id", updatedClient.id);

        const logoRes = await axios.post(
          `${base_url}/clients/upload_logo.php`,
          logoData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (logoRes.data.logo_path) {
          logoPath = logoRes.data.logo_path;
        }
      }

      // Upload attachments
      if (images && images.length > 0) {

        const attachData = new FormData();
        attachData.append("client_id", updatedClient.id);

        images.forEach((file) => {
          attachData.append("attachment[]", file);
        });

        const attachRes = await axios.post(
          `${base_url}/clients/upload_attachment.php`,
          attachData,
          { headers: { "Content-Type": "multipart/form-data" } }
        );

        if (attachRes.data.attachments) {
          attachmentPaths = attachRes.data.attachments;
        }
      }

      // Client data update
      const clientData = {
        id: updatedClient.id,
        name: updatedClient.name || "",
        company: updatedClient.company || "",
        email: updatedClient.email || "",
        phone: updatedClient.phone || "",
        website: updatedClient.website || "",
        address: updatedClient.address || "",
        status: updatedClient.status || "lead",
        source: updatedClient.source || "",
        notes: updatedClient.notes || "",
        logo: logoPath,
        attachment: attachmentPaths.length > 0 ? attachmentPaths.join(",") : null,
        payment_date: updatedClient.payment_date || null
      };

      if (updatedClient.plan_id) {
        clientData.plan_id = parseInt(updatedClient.plan_id);
      }

      const response = await axios.post(
        `${base_url}/clients/update_client.php`,
        clientData
      );

      if (response.data.success) {
        setEditingClient(null);
        fetchClients();
        toast.success("Client updated successfully!");
      } else {
        toast.error("Failed to update client");
      }

    } catch (error) {
      console.error("Error updating client:", error);
      toast.error("Server error");
    }
  };

  // Delete client
  const handleDeleteClient = async (id) => {
    if (window.confirm('Are you sure you want to delete this client?')) {
      try {
        await axios.delete(`${base_url}/clients/delete_client.php?id=${id}`);
        fetchClients();
        toast.success('Client deleted successfully');
      } catch (error) {
        console.error('Error deleting client:', error);
        toast.error('Error deleting client');
      }
    }
  };
  
  // Add this before the App function or import it from a separate file
  const EditClientModal = ({ client, onClose, onSave, base_url, plans }) => {
    const [formData, setFormData] = useState({
      id: client.id,
      name: client.name || '',
      company: client.company || '',
      email: client.email || '',
      phone: client.phone || '',
      website: client.website || '',
      address: client.address || '',
      status: client.status || 'lead',
      source: client.source || '',
      notes: client.notes || '',
      logo: client.logo || '',
      plan_id: client.plan_id || '',
      payment_date: client.payment_date || '',
      attachment: client.attachment || '',
    });

    const [logoFile, setLogoFile] = useState(null);
    const [logoPreview, setLogoPreview] = useState(client.logo ? `${base_url}/${client.logo}` : null);

    const handleLogoUpload = (e) => {
      const file = e.target.files[0];
      if (file) {
        setLogoFile(file);
        const reader = new FileReader();
        reader.onloadend = () => {
          setLogoPreview(reader.result);
        };
        reader.readAsDataURL(file);
      }
    };

    const handleSubmit = (e) => {
      e.preventDefault();
      // If there's a new logo file, you'll need to handle it separately
      // This might require FormData or base64 conversion depending on your API
      const submitData = { ...formData };
      if (logoFile) {
        // Handle logo file upload - you might need to convert to base64 or use FormData
        // For now, we'll just pass the file name or handle it separately
        submitData.logoFile = logoFile;
      }
      onSave(submitData);
    };

    return (
      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-y-auto">
        <div className="bg-white rounded-xl shadow-xl max-w-2xl w-full p-6 my-8">
          <h3 className="text-xl font-bold text-gray-800 mb-4">Edit Client</h3>
          <div className="flex-1 overflow-y-auto px-6">
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <select
                  value={formData.plan_id}
                  onChange={(e) => setFormData({ ...formData, plan_id: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="">Select Plan</option>
                  {plans.map(plan => (
                    <option key={plan.id} value={plan.id}>
                      {plan.name} - ₹{plan.price} ({plan.duration})
                    </option>
                  ))}
                </select>

                <input
                  type="date"
                  value={formData.payment_date}
                  onChange={(e) => setFormData({ ...formData, payment_date: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  placeholder="Name *"
                  value={formData.name}
                  onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
                <input
                  type="text"
                  placeholder="Company"
                  value={formData.company}
                  onChange={(e) => setFormData({ ...formData, company: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={formData.email}
                  onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="tel"
                  placeholder="Phone"
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  placeholder="Website"
                  value={formData.website}
                  onChange={(e) => setFormData({ ...formData, website: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <input
                  type="text"
                  placeholder="Address"
                  value={formData.address}
                  onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />
                <select
                  value={formData.status}
                  onChange={(e) => setFormData({ ...formData, status: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="lead">Lead</option>
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
                <input
                  type="text"
                  placeholder="Source (e.g., Website, Referral, Social Media)"
                  value={formData.source}
                  onChange={(e) => setFormData({ ...formData, source: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                />

              </div>

              {/* Logo Upload */}
              <div className="col-span-full">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Logo
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleLogoUpload}
                  className="px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 w-full"
                />
                {logoPreview && (
                  <div className="mt-2">
                    <img src={logoPreview} alt="Logo preview" className="h-20 w-20 object-cover rounded-lg" />
                  </div>
                )}
              </div>

              {/* Notes */}
              <div className="col-span-full">
                <textarea
                  placeholder="Notes"
                  value={formData.notes}
                  onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  rows="3"
                />
              </div>
              {/* Multiple Images Upload */}
              <div className="col-span-full mt-4">
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Additional Images
                </label>
                <input
                  type="file"
                  multiple
                  accept="image/*"
                  onChange={handleImagesUpload}
                  className="px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 w-full"
                />
                <p className="text-xs text-gray-500 mt-1">
                  You can select multiple images (JPG, PNG, GIF, etc.)
                </p>

                {/* Image Previews */}
                {imagePreviews.length > 0 && (
                  <div className="mt-4">
                    <p className="text-sm font-medium text-gray-700 mb-2">
                      Selected Images ({imagePreviews.length})
                    </p>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                      {imagePreviews.map((preview, index) => (
                        <div key={index} className="relative group">
                          <div className="aspect-square rounded-lg overflow-hidden bg-gray-100 border border-gray-200">
                            <img
                              src={preview.url}
                              alt={`Upload ${index + 1}`}
                              className="w-full h-full object-cover"
                            />
                          </div>
                          <button
                            type="button"
                            onClick={() => removeImage(index)}
                            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 opacity-0 group-hover:opacity-100 transition-opacity shadow-lg hover:bg-red-600"
                            title="Remove image"
                          >
                            <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            </svg>
                          </button>
                          <p className="text-xs text-gray-600 mt-1 truncate">{preview.name}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )}
              </div>
              <div className="flex gap-3 pt-4">
                <button
                  type="submit"
                  className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700"
                >
                  Update Client
                </button>
                <button
                  type="button"
                  onClick={onClose}
                  className="flex-1 bg-gray-100 text-gray-600 py-2 rounded-lg font-medium hover:bg-gray-200"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  };

  const loadAll = () => {
    fetchCampaigns();
    fetchPosters();
    fetchClients();
    fetchTasks();
    fetchEmployees();
    fetchProjects();
    fetchLeads();
    fetchFollowups();
    fetchPlans();
    fetchWhatsAppLogs();
    fetchInvoices();
    fetchSalaries();
    fetchEmployeeTaskStats();
  };
  const fetchSalaries = async () => {
  try {
    const res = await axios.get(`${base_url}/payroll/get_salaries.php`);
    if (res.data.success) {
      setSalaries(res.data.data);
    } else {
      setSalaries([]);
    }
  } catch (error) {
    console.error("Error fetching salaries:", error);
    setSalaries([]);
    toast.error('Failed to fetch salaries');
  }
};

// Fetch employee salary history
const fetchEmployeeSalaryHistory = async (employeeId) => {
  try {
    const res = await axios.get(`${base_url}/payroll/get_employee_salaries.php?employee_id=${employeeId}`);
    if (res.data.success) {
      return res.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching employee salary history:", error);
    return [];
  }
};

// Calculate net salary
const calculateNetSalary = (baseSalary, allowances, bonus, deductions) => {
  return baseSalary + allowances + bonus - deductions;
};

// Calculate detailed salary components
const calculateSalaryComponents = (baseSalary) => {
  // Example calculations - you can modify these rules
  const hra = baseSalary * 0.4; // 40% HRA
  const da = baseSalary * 0.1;   // 10% DA
  const ta = baseSalary * 0.05;  // 5% TA
  const medical = 1250;           // Fixed medical allowance
  const other_allowances = baseSalary * 0.1; // 10% other allowances
  
  const totalAllowances = hra + da + ta + medical + other_allowances;
  
  // Deductions
  const pf_deduction = Math.min(baseSalary * 0.12, 1800); // 12% PF, max 1800
  const professional_tax = baseSalary > 15000 ? 200 : 0;
  const income_tax = baseSalary > 50000 ? baseSalary * 0.1 : 0; // Example tax calculation
  
  const totalDeductions = pf_deduction + professional_tax + income_tax;
  
  return {
    hra, da, ta, medical, other_allowances,
    pf_deduction, professional_tax, income_tax,
    totalAllowances, totalDeductions
  };
};

// Handle salary form input changes
const handleSalaryInputChange = (e) => {
  const { name, value } = e.target;
  let updatedForm = { ...salaryForm, [name]: value };
  
  // Auto-calculate net salary when base_salary, allowances, bonus, or deductions change
  if (['base_salary', 'allowances', 'bonus', 'deductions'].includes(name)) {
    const baseSalary = parseFloat(updatedForm.base_salary) || 0;
    const allowances = parseFloat(updatedForm.allowances) || 0;
    const bonus = parseFloat(updatedForm.bonus) || 0;
    const deductions = parseFloat(updatedForm.deductions) || 0;
    updatedForm.net_salary = calculateNetSalary(baseSalary, allowances, bonus, deductions);
  }
  
  setSalaryForm(updatedForm);
};

// Handle salary components change
const handleSalaryComponentsChange = (e) => {
  const { name, value } = e.target;
  const updatedComponents = { ...salaryComponents, [name]: parseFloat(value) || 0 };
  
  // Calculate total allowances and deductions
  const totalAllowances = updatedComponents.hra + updatedComponents.da + 
                          updatedComponents.ta + updatedComponents.medical + 
                          updatedComponents.other_allowances;
  const totalDeductions = updatedComponents.pf_deduction + 
                          updatedComponents.professional_tax + 
                          updatedComponents.income_tax + 
                          updatedComponents.other_deductions;
  
  setSalaryComponents(updatedComponents);
  
  // Update salary form
  setSalaryForm(prev => ({
    ...prev,
    allowances: totalAllowances,
    deductions: totalDeductions,
    net_salary: calculateNetSalary(prev.base_salary, totalAllowances, prev.bonus, totalDeductions)
  }));
};

// Auto-calculate components based on base salary
const autoCalculateComponents = () => {
  const baseSalary = parseFloat(salaryForm.base_salary) || 0;
  const components = calculateSalaryComponents(baseSalary);
  
  setSalaryComponents({
    hra: components.hra,
    da: components.da,
    ta: components.ta,
    medical: components.medical,
    other_allowances: components.other_allowances,
    pf_deduction: components.pf_deduction,
    professional_tax: components.professional_tax,
    income_tax: components.income_tax,
    other_deductions: 0
  });
  
  setSalaryForm(prev => ({
    ...prev,
    allowances: components.totalAllowances,
    deductions: components.totalDeductions,
    net_salary: calculateNetSalary(baseSalary, components.totalAllowances, prev.bonus, components.totalDeductions)
  }));
  
  toast.success('Salary components auto-calculated');
};

// Add new salary record
const handleAddSalary = async () => {
  if (!salaryForm.employee_id) {
    toast.error('Please select an employee');
    return;
  }
  
  if (salaryForm.base_salary <= 0) {
    toast.error('Please enter a valid base salary');
    return;
  }
  
  try {
    const salaryData = {
      ...salaryForm,
      base_salary: parseFloat(salaryForm.base_salary),
      allowances: parseFloat(salaryForm.allowances),
      bonus: parseFloat(salaryForm.bonus),
      deductions: parseFloat(salaryForm.deductions),
      net_salary: parseFloat(salaryForm.net_salary),
      salary_components: JSON.stringify(salaryComponents)
    };
    
    const response = await axios.post(`${base_url}/payroll/add_salary.php`, salaryData);
    
    if (response.data.success) {
      setShowAddSalary(false);
      resetSalaryForm();
      fetchSalaries();
      toast.success('Salary record added successfully!');
    } else {
      throw new Error(response.data.error || 'Failed to add salary record');
    }
  } catch (error) {
    console.error('Error adding salary:', error);
    toast.error('Failed to add salary record: ' + (error.response?.data?.error || error.message));
  }
};

// Reset salary form
const resetSalaryForm = () => {
  setSalaryForm({
    employee_id: "",
    base_salary: 0,
    allowances: 0,
    bonus: 0,
    deductions: 0,
    net_salary: 0,
    salary_month: new Date().toISOString().slice(0, 7),
    payment_date: new Date().toISOString().split('T')[0],
    payment_method: "bank_transfer",
    status: "pending",
    notes: ""
  });
  setSalaryComponents({
    hra: 0, da: 0, ta: 0, medical: 0, other_allowances: 0,
    pf_deduction: 0, professional_tax: 0, income_tax: 0, other_deductions: 0
  });
};

// Update salary status
const handleUpdateSalaryStatus = async (salaryId, newStatus) => {
  try {
    const response = await axios.post(`${base_url}/payroll/update_salary_status.php`, {
      id: salaryId,
      status: newStatus
    });
    
    if (response.data.success) {
      fetchSalaries();
      toast.success('Salary status updated successfully!');
    }
  } catch (error) {
    console.error('Error updating salary status:', error);
    toast.error('Failed to update salary status');
  }
};

// Delete salary record
const handleDeleteSalary = async (salaryId) => {
  if (window.confirm('Are you sure you want to delete this salary record?')) {
    try {
      const response = await axios.delete(`${base_url}/payroll/delete_salary.php?id=${salaryId}`);
      
      if (response.data.success) {
        fetchSalaries();
        toast.success('Salary record deleted successfully!');
      }
    } catch (error) {
      console.error('Error deleting salary:', error);
      toast.error('Failed to delete salary record');
    }
  }
};

// Generate payroll report
const generatePayrollReport = async (month) => {
  try {
    const response = await axios.get(`${base_url}/payroll/generate_report.php?month=${month}`);
    if (response.data.success) {
      // Create download link for report
      const blob = new Blob([JSON.stringify(response.data.data, null, 2)], { type: 'application/json' });
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `payroll_report_${month}.json`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      toast.success('Report generated successfully!');
    }
  } catch (error) {
    console.error('Error generating report:', error);
    toast.error('Failed to generate report');
  }
};

// Get salary status color
const getSalaryStatusColor = (status) => {
  switch (status) {
    case 'paid': return 'bg-green-100 text-green-800';
    case 'pending': return 'bg-yellow-100 text-yellow-800';
    case 'cancelled': return 'bg-red-100 text-red-800';
    default: return 'bg-gray-100 text-gray-800';
  }
};

// Get payment method icon
const getPaymentMethodIcon = (method) => {
  switch (method) {
    case 'bank_transfer': return '🏦';
    case 'cash': return '💵';
    case 'check': return '📝';
    default: return '💰';
  }
};

// Add Salary Modal Component
const AddSalaryModal = ({ show, onClose, employees, onSubmit }) => {
  if (!show) return null;
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-gray-800">Create Salary Record</h3>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FiX size={24} />
            </button>
          </div>
          
          <div className="space-y-6">
            {/* Basic Information */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Employee *
                </label>
                <select
                  name="employee_id"
                  value={salaryForm.employee_id}
                  onChange={handleSalaryInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                >
                  <option value="">Select Employee</option>
                  {employees.map(emp => (
                    <option key={emp.id} value={emp.id}>
                      {emp.name} {emp.code ? `(${emp.code})` : ''}
                    </option>
                  ))}
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Salary Month *
                </label>
                <input
                  type="month"
                  name="salary_month"
                  value={salaryForm.salary_month}
                  onChange={handleSalaryInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Payment Date *
                </label>
                <input
                  type="date"
                  name="payment_date"
                  value={salaryForm.payment_date}
                  onChange={handleSalaryInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Payment Method
                </label>
                <select
                  name="payment_method"
                  value={salaryForm.payment_method}
                  onChange={handleSalaryInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="bank_transfer">Bank Transfer</option>
                  <option value="cash">Cash</option>
                  <option value="check">Check</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Status
                </label>
                <select
                  name="status"
                  value={salaryForm.status}
                  onChange={handleSalaryInputChange}
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="pending">Pending</option>
                  <option value="paid">Paid</option>
                  <option value="cancelled">Cancelled</option>
                </select>
              </div>
              
              <div className="md:col-span-2">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Notes
                </label>
                <textarea
                  name="notes"
                  value={salaryForm.notes}
                  onChange={handleSalaryInputChange}
                  rows="2"
                  className="w-full px-3 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="Additional notes..."
                />
              </div>
            </div>
            
            {/* Salary Components Section */}
            <div className="border-t border-gray-200 pt-4">
              <div className="flex justify-between items-center mb-4">
                <h4 className="text-lg font-semibold text-gray-800">Salary Components</h4>
                <button
                  type="button"
                  onClick={autoCalculateComponents}
                  className="px-3 py-1 bg-blue-100 text-blue-600 rounded-lg text-sm hover:bg-blue-200"
                >
                  Auto Calculate
                </button>
              </div>
              
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                {/* Allowances Section */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h5 className="font-medium text-gray-700 mb-3">Allowances</h5>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">HRA (40%)</label>
                      <input
                        type="number"
                        name="hra"
                        value={salaryComponents.hra}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">DA (10%)</label>
                      <input
                        type="number"
                        name="da"
                        value={salaryComponents.da}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">TA (5%)</label>
                      <input
                        type="number"
                        name="ta"
                        value={salaryComponents.ta}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">Medical Allowance</label>
                      <input
                        type="number"
                        name="medical"
                        value={salaryComponents.medical}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">Other Allowances</label>
                      <input
                        type="number"
                        name="other_allowances"
                        value={salaryComponents.other_allowances}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                  </div>
                </div>
                
                {/* Deductions Section */}
                <div className="border border-gray-200 rounded-lg p-4">
                  <h5 className="font-medium text-gray-700 mb-3">Deductions</h5>
                  <div className="space-y-3">
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">PF Deduction (12%)</label>
                      <input
                        type="number"
                        name="pf_deduction"
                        value={salaryComponents.pf_deduction}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">Professional Tax</label>
                      <input
                        type="number"
                        name="professional_tax"
                        value={salaryComponents.professional_tax}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">Income Tax (TDS)</label>
                      <input
                        type="number"
                        name="income_tax"
                        value={salaryComponents.income_tax}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                    <div className="flex justify-between items-center">
                      <label className="text-sm text-gray-600">Other Deductions</label>
                      <input
                        type="number"
                        name="other_deductions"
                        value={salaryComponents.other_deductions}
                        onChange={handleSalaryComponentsChange}
                        className="w-32 px-2 py-1 border rounded text-right"
                        step="0.01"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Salary Summary */}
            <div className="bg-gray-50 rounded-lg p-4">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Base Salary</label>
                  <input
                    type="number"
                    name="base_salary"
                    value={salaryForm.base_salary}
                    onChange={handleSalaryInputChange}
                    className="w-full px-3 py-2 border rounded-lg font-semibold"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Total Allowances</label>
                  <input
                    type="text"
                    value={`₹${parseFloat(salaryForm.allowances).toLocaleString()}`}
                    readOnly
                    className="w-full px-3 py-2 bg-green-50 border border-green-200 rounded-lg font-semibold text-green-700"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Bonus</label>
                  <input
                    type="number"
                    name="bonus"
                    value={salaryForm.bonus}
                    onChange={handleSalaryInputChange}
                    className="w-full px-3 py-2 border rounded-lg"
                    step="0.01"
                  />
                </div>
                <div>
                  <label className="block text-xs text-gray-500 mb-1">Total Deductions</label>
                  <input
                    type="text"
                    value={`₹${parseFloat(salaryForm.deductions).toLocaleString()}`}
                    readOnly
                    className="w-full px-3 py-2 bg-red-50 border border-red-200 rounded-lg font-semibold text-red-700"
                  />
                </div>
              </div>
              
              <div className="mt-4 pt-4 border-t border-gray-200">
                <div className="flex justify-between items-center">
                  <span className="text-lg font-bold text-gray-800">Net Salary</span>
                  <span className="text-2xl font-bold text-blue-600">
                    ₹{parseFloat(salaryForm.net_salary).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
          </div>
          
          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
            >
              Cancel
            </button>
            <button
              onClick={handleAddSalary}
              className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 text-white rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700"
            >
              Create Salary Record
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

// Salary Details Modal
const SalaryDetailsModal = ({ show, onClose, salary, employees }) => {
  if (!show || !salary) return null;
  
  const employee = employees.find(e => e.id == salary.employee_id);
  let salaryComponentsData = {};
  
  try {
    if (salary.salary_components) {
      salaryComponentsData = typeof salary.salary_components === 'string' 
        ? JSON.parse(salary.salary_components) 
        : salary.salary_components;
    }
  } catch (e) {
    console.error('Error parsing salary components:', e);
  }
  
  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-3xl max-h-[90vh] overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-gray-800">Salary Details</h3>
            <button onClick={onClose} className="text-gray-500 hover:text-gray-700">
              <FiX size={24} />
            </button>
          </div>
          
          <div className="space-y-6">
            {/* Employee Info */}
            {employee && (
              <div className="bg-gray-50 p-4 rounded-lg">
                <h4 className="font-semibold text-gray-700 mb-2">Employee Information</h4>
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <p className="text-sm text-gray-500">Name</p>
                    <p className="font-medium">{employee.name}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Employee Code</p>
                    <p className="font-medium">{employee.code || 'N/A'}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Salary Month</p>
                    <p className="font-medium">{salary.salary_month}</p>
                  </div>
                  <div>
                    <p className="text-sm text-gray-500">Payment Date</p>
                    <p className="font-medium">{new Date(salary.payment_date).toLocaleDateString()}</p>
                  </div>
                </div>
              </div>
            )}
            
            {/* Salary Components */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {/* Allowances */}
              <div className="border border-gray-200 rounded-lg p-4">
                <h4 className="font-semibold text-gray-700 mb-3">Allowances</h4>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">HRA:</span>
                    <span>₹{salaryComponentsData.hra?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">DA:</span>
                    <span>₹{salaryComponentsData.da?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">TA:</span>
                    <span>₹{salaryComponentsData.ta?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Medical Allowance:</span>
                    <span>₹{salaryComponentsData.medical?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between border-t pt-2 mt-2">
                    <span className="font-semibold">Total Allowances:</span>
                    <span className="font-semibold text-green-600">₹{parseFloat(salary.allowances).toLocaleString()}</span>
                  </div>
                </div>
              </div>
              
              {/* Deductions */}
              <div className="border border-gray-200 rounded-lg p-4">
                <h4 className="font-semibold text-gray-700 mb-3">Deductions</h4>
                <div className="space-y-2">
                  <div className="flex justify-between">
                    <span className="text-gray-600">PF Deduction:</span>
                    <span>₹{salaryComponentsData.pf_deduction?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Professional Tax:</span>
                    <span>₹{salaryComponentsData.professional_tax?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-gray-600">Income Tax (TDS):</span>
                    <span>₹{salaryComponentsData.income_tax?.toLocaleString() || 0}</span>
                  </div>
                  <div className="flex justify-between border-t pt-2 mt-2">
                    <span className="font-semibold">Total Deductions:</span>
                    <span className="font-semibold text-red-600">₹{parseFloat(salary.deductions).toLocaleString()}</span>
                  </div>
                </div>
              </div>
            </div>
            
            {/* Salary Summary */}
            <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg p-4">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-4">
                <div>
                  <p className="text-sm text-gray-500">Base Salary</p>
                  <p className="text-lg font-semibold">₹{parseFloat(salary.base_salary).toLocaleString()}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Bonus</p>
                  <p className="text-lg font-semibold">₹{parseFloat(salary.bonus).toLocaleString()}</p>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Status</p>
                  <span className={`inline-block px-2 py-1 text-xs rounded-full ${getSalaryStatusColor(salary.status)}`}>
                    {salary.status}
                  </span>
                </div>
                <div>
                  <p className="text-sm text-gray-500">Payment Method</p>
                  <p className="text-lg">{getPaymentMethodIcon(salary.payment_method)} {salary.payment_method?.replace('_', ' ')}</p>
                </div>
              </div>
              
              <div className="border-t border-blue-200 pt-4">
                <div className="flex justify-between items-center">
                  <span className="text-xl font-bold text-gray-800">Net Salary</span>
                  <span className="text-3xl font-bold text-blue-600">
                    ₹{parseFloat(salary.net_salary).toLocaleString()}
                  </span>
                </div>
              </div>
            </div>
            
            {/* Notes */}
            {salary.notes && (
              <div>
                <h4 className="font-semibold text-gray-700 mb-1">Notes</h4>
                <p className="text-sm text-gray-600 bg-gray-50 p-3 rounded">{salary.notes}</p>
              </div>
            )}
          </div>
          
          <div className="flex justify-end gap-3 mt-6">
            <button
              onClick={onClose}
              className="px-4 py-2 bg-gray-100 text-gray-600 rounded-lg hover:bg-gray-200"
            >
              Close
            </button>
            {salary.status !== 'paid' && (
              <button
                onClick={() => {
                  handleUpdateSalaryStatus(salary.id, 'paid');
                  onClose();
                }}
                className="px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700"
              >
                Mark as Paid
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
  const fetchWhatsAppLogs = async () => {
    try {
      const res = await axios.get(`${base_url}/whatsapp/get_whatsapp_logs.php`);
      if (res.data.success) {
        setWhatsappLogs(res.data.data);
      }
    } catch (error) {
      console.error('Error fetching WhatsApp logs:', error);
      toast.error('Failed to fetch WhatsApp logs');
    }
  };

  const fetchPlans = async () => {
    try {
      const res = await axios.get(`${base_url}/plans/get_plans.php`);
      if (Array.isArray(res.data)) {
        setPlans(res.data);
      } else if (Array.isArray(res.data.data)) {
        setPlans(res.data.data);
      } else {
        setPlans([]);
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      setPlans([]);
      toast.error('Failed to fetch plans');
    }
  };
  // Add new plan
const addPlan = async () => {
  if (!planForm.name || !planForm.price) {
    toast.error('Please fill all required fields');
    return;
  }

  try {
    const response = await axios.post(`${base_url}/plans/add_plan.php`, planForm);
    if (response.data.success) {
      fetchPlans();
      resetPlanForm();
      setShowPlanModal(false);
      toast.success('Plan added successfully!');
    } else {
      toast.error(response.data.message || 'Failed to add plan');
    }
  } catch (error) {
    console.error('Error adding plan:', error);
    toast.error('Error adding plan');
  }
};

// Update plan
const updatePlan = async () => {
  if (!planForm.name || !planForm.price) {
    toast.error('Please fill all required fields');
    return;
  }

  try {
    const response = await axios.post(`${base_url}/plans/update_plan.php`, {
      id: editingPlan.id,
      ...planForm
    });
    if (response.data.success) {
      fetchPlans();
      resetPlanForm();
      setEditingPlan(null);
      setShowPlanModal(false);
      toast.success('Plan updated successfully!');
    } else {
      toast.error(response.data.message || 'Failed to update plan');
    }
  } catch (error) {
    console.error('Error updating plan:', error);
    toast.error('Error updating plan');
  }
};

// Delete plan
const deletePlan = async (planId) => {
  if (!window.confirm('Are you sure you want to delete this plan?')) return;

  try {
    const response = await axios.delete(`${base_url}/plans/delete_plan.php`, {
      data: { id: planId }
    });
    if (response.data.success) {
      fetchPlans();
      toast.success('Plan deleted successfully!');
    } else {
      toast.error(response.data.message || 'Failed to delete plan');
    }
  } catch (error) {
    console.error('Error deleting plan:', error);
    toast.error('Error deleting plan');
  }
};

// Reset plan form
const resetPlanForm = () => {
  setPlanForm({
    name: "",
    price: "",
    duration: "monthly",
    status: "active"
  });
};

// Open edit modal
const openEditPlanModal = (plan) => {
  setEditingPlan(plan);
  setPlanForm({
    name: plan.name,
    price: plan.price,
    duration: plan.duration,
    status: plan.status
  });
  setShowPlanModal(true);
};

// Open add modal
const openAddPlanModal = () => {
  resetPlanForm();
  setEditingPlan(null);
  setShowPlanModal(true);
};
// Plan Modal Component
// Simpler Plan Modal Component
const PlanModal = ({ show, onClose, onSave, editingPlan, planForm, setPlanForm }) => {
  if (!show) return null;

  const handleNameChange = (e) => {
    setPlanForm({ ...planForm, name: e.target.value });
  };

  const handlePriceChange = (e) => {
    setPlanForm({ ...planForm, price: e.target.value });
  };

  const handleDurationChange = (e) => {
    setPlanForm({ ...planForm, duration: e.target.value });
  };

  const handleStatusChange = (e) => {
    setPlanForm({ ...planForm, status: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSave();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full">
        <div className="p-6">
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-bold text-gray-800">
              {editingPlan ? 'Edit Plan' : 'Add New Plan'}
            </h3>
            <button onClick={onClose} className="text-gray-400 hover:text-gray-600">
              <FiX size={24} />
            </button>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Plan Name *
                </label>
                <input
                  type="text"
                  value={planForm.name}
                  onChange={handleNameChange}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="e.g., Basic Plan, Premium Plan"
                  autoFocus
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Price (₹) *
                </label>
                <input
                  type="number"
                  value={planForm.price}
                  onChange={handlePriceChange}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                  placeholder="0.00"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Duration *
                </label>
                <select
                  value={planForm.duration}
                  onChange={handleDurationChange}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="monthly">Monthly</option>
                  <option value="half-yearly">Half Yearly</option>
                  <option value="yearly">Yearly</option>
                </select>
              </div>
              
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Status
                </label>
                <select
                  value={planForm.status}
                  onChange={handleStatusChange}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                >
                  <option value="active">Active</option>
                  <option value="inactive">Inactive</option>
                </select>
              </div>
            </div>

            <div className="flex gap-3 pt-6">
              <button
                type="submit"
                className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700"
              >
                {editingPlan ? 'Update Plan' : 'Add Plan'}
              </button>
              <button
                type="button"
                onClick={onClose}
                className="flex-1 bg-gray-100 text-gray-600 py-2 rounded-lg font-medium hover:bg-gray-200"
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};
  const fetchPosters = async () => {
    try {
      const res = await axios.get(`${base_url}/posters/get_posters.php`);

      if (Array.isArray(res.data)) {
        setPosters(res.data);
      } else if (Array.isArray(res.data.data)) {
        setPosters(res.data.data);
      } else {
        setPosters([]);
      }

    } catch (error) {
      console.error("Poster fetch error", error);
      setPosters([]);
      toast.error('Failed to fetch posters');
    }
  };

  const fetchClients = async () => {
    try {
      const res = await axios.get(`${base_url}/clients/get_clients.php`);

      if (Array.isArray(res.data)) {
        setClients(res.data);
      } else if (Array.isArray(res.data.data)) {
        setClients(res.data.data);
      } else {
        setClients([]);
      }

    } catch (error) {
      console.error("Clients fetch error", error);
      setClients([]);
      toast.error('Failed to fetch clients');
    }
  };
  
  // In your fetchTasks function, add this processing
  const fetchTasks = async () => {
    try {
      const res = await axios.get(`${base_url}/get_tasks.php`);
      // Process tasks to add contact_type field
      const processedTasks = (res.data.data || []).map(task => ({
        ...task,
        contact_type: task.client_id ? 'client' : (task.lead_id ? 'lead' : null)
      }));
      setTasks(processedTasks);
    } catch (error) {
      console.error("Error fetching tasks:", error);
      setTasks([]);
      toast.error('Failed to fetch tasks');
    }
  };
  const handleDeleteTask = async (taskId) => {
    // Show confirmation dialog
    if (!window.confirm('Are you sure you want to delete this task?')) {
      return;
    }

    try {
      // Send task ID as query parameter
      const res = await axios.delete(`${base_url}/delete_tasks.php`, {
        params: { id: taskId }  // This is cleaner than string concatenation
      });
      
      // Check if deletion was successful
      if (res.data.success) {
        // Update local state by removing the deleted task
        setTasks(prevTasks => prevTasks.filter(task => task.id !== taskId));
        
        // Show success message
        toast.success(res.data.message || 'Task deleted successfully');
      } else {
        toast.error(res.data.message || 'Failed to delete task');
      }
    } catch (error) {
      console.error("Error deleting task:", error);
      
      // Better error handling
      if (error.response) {
        toast.error(error.response.data?.message || 'Failed to delete task');
      } else if (error.request) {
        toast.error('No response from server. Please check your connection.');
      } else {
        toast.error('Failed to delete task. Please try again.');
      }
    }
  };
  const fetchEmployeeTaskStats = async () => {
    try {
        const response = await axios.get(`${base_url}/get_employee_task_stats.php`);
        console.log("response", response);
        if (response.data.success) {
            setEmployeeTaskStats(response.data.data);
            setDashboardSummary({
                total_tasks: response.data.summary?.total_tasks || 0,
                today_tasks: response.data.summary?.today_tasks || 0,
                completed_tasks: response.data.summary?.completed_tasks || 0
            });
            setWeeklyTrends(response.data.weekly_trends || []);
            setProjectDistribution(response.data.project_distribution || []);
        } else {
            setEmployeeTaskStats([]);
        }
    } catch (error) {
        console.error("Error fetching employee task stats:", error);
        setEmployeeTaskStats([]);
    }
};
  const fetchEmployeeTasks = async () => {
    try {
      const res = await axios.get(`${base_url}/auth/employee_tasks.php`);
      // Process tasks to add contact_type field
      const processedTasks = (res.data || []).map(task => ({
        ...task,
        contact_type: task.client_id ? 'client' : (task.lead_id ? 'lead' : null)
      }));
      setEmployeeTasks(processedTasks);
    } catch (error) {
      console.error("Error fetching employee tasks:", error);
      setEmployeeTasks([]);
      toast.error('Failed to fetch employee tasks');
    }
  };

  const fetchEmployees = async () => {
    try {
      const res = await axios.get(`${base_url}/get_employees.php`);
      setEmployees(res.data);
    } catch (error) {
      console.error("Error fetching employees:", error);
      toast.error('Failed to fetch employees');
    }
  };

  const fetchProjects = async () => {
    try {
      const res = await axios.get(`${base_url}/get_projects.php`);
      setProjects(res.data.data || []);
    } catch (error) {
      console.error("Error fetching projects:", error);
      toast.error('Failed to fetch projects');
    }
  };

  // Sales functions
  const fetchLeads = async () => {
    try {
      const res = await axios.get(`${base_url}/sales/get_leads.php`);
      setLeads(res.data);
    } catch (error) {
      console.error("Error fetching leads:", error);
      toast.error('Failed to fetch leads');
    }
  };

  const fetchFollowups = async () => {
    try {
      const res = await axios.get(`${base_url}/sales/get_followups.php`);
      setFollowups(res.data);
    } catch (error) {
      console.error("Error fetching followups:", error);
      toast.error('Failed to fetch followups');
    }
  };

  const addLead = async () => {
    try {
      await axios.post(`${base_url}/sales/add_lead.php`, leadForm);
      setShowAddLead(false);
      setLeadForm({
        name: "",
        payment_date: "",
        company: "",
        email: "",
        phone: "",
        status: "new",
        source: "website",
        notes: ""
      });
      fetchLeads();
      toast.success('Lead added successfully');
    } catch (error) {
      console.error("Error adding lead:", error);
      toast.error("Failed to add lead");
    }
  };

  const updateLead = async (id, data) => {
    try {
      await axios.post(`${base_url}/sales/update_lead.php`, { id, ...data });
      fetchLeads();
      toast.success('Lead updated successfully');
    } catch (error) {
      console.error("Error updating lead:", error);
      toast.error('Failed to update lead');
    }
  };

  const deleteLead = async (id) => {
    if (window.confirm("Are you sure you want to delete this lead?")) {
      try {
        await axios.post(`${base_url}/sales/delete_lead.php`, { id });
        fetchLeads();
        toast.success('Lead deleted successfully');
      } catch (error) {
        console.error("Error deleting lead:", error);
        toast.error('Failed to delete lead');
      }
    }
  };

// Convert lead to client
const convertLeadToClient = async () => {
  if (!selectedLeadForConversion) return;

  try {
    // Validate required fields
    if (!conversionForm.name) {
      toast.error('Client name is required');
      return;
    }

    // First create client from lead data
    const clientData = {
      name: conversionForm.name || selectedLeadForConversion.name,
      company: conversionForm.company || selectedLeadForConversion.company,
      email: conversionForm.email || selectedLeadForConversion.email,
      phone: conversionForm.phone || selectedLeadForConversion.phone,
      website: conversionForm.website || "",
      address: conversionForm.address || "",
      plan_id: conversionForm.plan_id || "",
      payment_date: conversionForm.payment_date || "",
      create_invoice: conversionForm.create_invoice || false  // Add checkbox value here
    };

    const clientRes = await axios.post(`${base_url}/clients/add_client.php`, clientData);

    if (clientRes.data.status || clientRes.data.id) {
      await axios.post(`${base_url}/add_project.php`, {
        name: conversionForm.company || selectedLeadForConversion.company
      });
      const clientId = clientRes.data.id || clientRes.data.client_id;

      // If checkbox is checked, create invoice
      if (conversionForm.create_invoice) {
        try {
          const invoiceData = {
            client_id: clientId,
            client_name: conversionForm.name || selectedLeadForConversion.name,
            plan_id: conversionForm.plan_id,
            amount: getPlanPrice(conversionForm.plan_id), // You'll need to implement this function
            due_date: conversionForm.payment_date,
            status: 'pending'
          };
          
          // Call your invoice creation API
          // await axios.post(`${base_url}/invoices/add_invoice.php`, invoiceData);
          toast.success("Invoice created successfully!");
        } catch (invoiceError) {
          console.error("Error creating invoice:", invoiceError);
          toast.warning("Client created but invoice generation failed");
        }
      }

      // Update lead status to 'won'
      await updateLead(selectedLeadForConversion.id, { status: 'won' });

      toast.success("Lead successfully converted to client!");

      setShowConvertLeadModal(false);
      setSelectedLeadForConversion(null);
      setConversionForm({
        name: "",
        company: "",
        email: "",
        phone: "",
        website: "",
        address: "",
        plan_id: "",
        payment_date: "",
        create_invoice: false  // Add this to reset
      });

      // Refresh data
      fetchClients();
      fetchLeads();
      fetchTasks();
      fetchEmployeeTasks();
    }
  } catch (error) {
    console.error("Error converting lead to client:", error);
    toast.error("Failed to convert lead to client");
  }
};

// Helper function to get plan price (implement based on your plans array)
const getPlanPrice = (planId) => {
  const plan = plans.find(p => p.id === planId);
  return plan ? plan.price : 0;
};

  const addFollowup = async () => {
    try {
      await axios.post(`${base_url}/sales/add_followup.php`, followupForm);
      setShowAddFollowup(false);
      setFollowupForm({
        lead_id: "",
        followup_date: "",
        followup_time: "",
        status: "pending",
        notes: "",
        next_followup_date: "",
        next_followup_time: ""
      });
      fetchFollowups();
      toast.success('Follow-up added successfully');
    } catch (error) {
      console.error("Error adding followup:", error);
      toast.error("Failed to add followup");
    }
  };

  const updateFollowup = async (id, data) => {
    try {
      await axios.post(`${base_url}/sales/update_followup.php`, { id, ...data });
      setEditingFollowup(null);
      fetchFollowups();
      toast.success('Follow-up updated successfully');
    } catch (error) {
      console.error("Error updating followup:", error);
      toast.error('Failed to update followup');
    }
  };

  const deleteFollowup = async (id) => {
    if (window.confirm("Are you sure you want to delete this followup?")) {
      try {
        await axios.post(`${base_url}/sales/delete_followup.php`, { id });
        fetchFollowups();
        toast.success('Follow-up deleted successfully');
      } catch (error) {
        console.error("Error deleting followup:", error);
        toast.error('Failed to delete followup');
      }
    }
  };
  
  const getLeadStatusColor = (status) => {
    switch (status) {
      case 'new': return 'bg-blue-100 text-blue-800';
      case 'contacted': return 'bg-yellow-100 text-yellow-800';
      case 'qualified': return 'bg-green-100 text-green-800';
      case 'proposal': return 'bg-purple-100 text-purple-800';
      case 'negotiation': return 'bg-orange-100 text-orange-800';
      case 'won': return 'bg-emerald-100 text-emerald-800';
      case 'lost': return 'bg-red-100 text-red-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const getFollowupStatusColor = (status) => {
    switch (status) {
      case 'pending': return 'bg-yellow-100 text-yellow-800';
      case 'completed': return 'bg-green-100 text-green-800';
      case 'cancelled': return 'bg-red-100 text-red-800';
      case 'rescheduled': return 'bg-purple-100 text-purple-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  const addTask = async () => {
    if (!title || !employeeId || !projectId) {
      toast.error("Please fill all required fields");
      return;
    }

    try {
      await axios.post(`${base_url}/add_task.php`, {
        title,
        employee_id: employeeId,
        project_id: projectId,
        lead_id: leadId
      });

      setTitle("");
      setLeadId("");
      fetchTasks();
      toast.success("Task added successfully");
    } catch (error) {
      console.error("Error adding task:", error);
      toast.error("Failed to add task");
    }
  };

  const updateStatus = async (id, status) => {
    try {
      await axios.post(`${base_url}/update_status.php`, { id, status });
      fetchTasks();
      toast.success("Task status updated");
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Failed to update task status");
    }
  };

  const updateEmployeeTaskStatus = async (id, newStatus) => {
    try {
      await axios.post(`${base_url}/update_status.php`, {
        id,
        status: newStatus
      });
      fetchEmployeeTasks();
      toast.success("Task status updated");
    } catch (error) {
      console.error("Error updating task status:", error);
      toast.error("Failed to update task status");
    }
  };

  const addEmployee = async () => {
    if (!newEmployee) {
      toast.error("Please enter employee name");
      return;
    }
    try {
      await axios.post(`${base_url}/add_employee.php`, {
        name: newEmployee
      });
      setNewEmployee("");
      fetchEmployees();
      toast.success("Employee added successfully");
    } catch (error) {
      console.error("Error adding employee:", error);
      toast.error("Failed to add employee");
    }
  };

  const addProject = async () => {
    if (!newProject) {
      toast.error("Please enter project name");
      return;
    }
    try {
      await axios.post(`${base_url}/add_project.php`, {
        name: newProject
      });
      setNewProject("");
      fetchProjects();
      toast.success("Project added successfully");
    } catch (error) {
      console.error("Error adding project:", error);
      toast.error("Failed to add project");
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'todo': return <FiAlertCircle className="text-yellow-500" />;
      case 'inprogress': return <FiClock className="text-blue-500" />;
      case 'done': return <FiCheckCircle className="text-green-500" />;
      default: return null;
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'todo': return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      case 'inprogress': return 'bg-blue-100 text-blue-800 border-blue-200';
      case 'done': return 'bg-green-100 text-green-800 border-green-200';
      default: return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusBadge = (status) => {
    switch (status) {
      case 'todo': return 'bg-yellow-100 text-yellow-800';
      case 'inprogress': return 'bg-blue-100 text-blue-800';
      case 'done': return 'bg-green-100 text-green-800';
      default: return 'bg-gray-100 text-gray-800';
    }
  };

  // Employee-specific functions
  const fetchClientPosters = async (clientId) => {
    try {
      setLoading(true);
      const res = await axios.get(`${base_url}/posters/get_client_posters.php?client_id=${clientId}`);
      if (Array.isArray(res.data)) {
        setClientPosters(res.data);
      } else if (Array.isArray(res.data.data)) {
        setClientPosters(res.data.data);
      } else {
        setClientPosters([]);
      }
    } catch (error) {
      console.error("Error fetching client posters:", error);
      setClientPosters([]);
      toast.error('Failed to fetch client posters');
    } finally {
      setLoading(false);
    }
  };

  const handleTaskClick = (task) => {
    setSelectedTaskDetails(task);
    setShowClientDetails(true);
    fetchClients();
  };

  const downloadImage = async (imagePath, fileName) => {
    try {
      const response = await fetch(`${base_url}/${imagePath}`);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = fileName || 'poster.jpg';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      toast.success('Download started');
    } catch (error) {
      console.error("Error downloading image:", error);
      toast.error("Failed to download image");
    }
  };

  // Continue with the rest of your component...

  if (authType === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Checking session...</p>
        </div>
      </div>
    );
  }

  if (!authType) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 to-indigo-100 p-4">
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              padding: '16px',
              borderRadius: '8px',
              fontSize: '14px',
              maxWidth: '400px',
            },
            success: {
              duration: 4000,
              style: {
                background: '#10b981',
                color: '#fff',
              },
              iconTheme: {
                primary: '#fff',
                secondary: '#10b981',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#ef4444',
                color: '#fff',
              },
              iconTheme: {
                primary: '#fff',
                secondary: '#ef4444',
              },
            },
          }}
        />
        <div className="bg-white/80 backdrop-blur-lg p-8 rounded-2xl shadow-xl w-full max-w-md border border-white/20">
          <div className="text-center mb-8">
            <h1 className="text-3xl font-bold bg-gradient-to-r from-blue-600 to-indigo-600 bg-clip-text text-transparent">
              TaskFlow CRM
            </h1>
            <p className="text-gray-500 mt-2">Manage your tasks efficiently</p>
          </div>

          <div className="flex gap-2 mb-6 bg-gray-100 p-1 rounded-lg">
            <button
              onClick={() => setLoginMode("admin")}
              className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all ${loginMode === "admin"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:text-gray-800"
                }`}
            >
              Admin
            </button>
            <button
              onClick={() => setLoginMode("employee")}
              className={`flex-1 py-2 rounded-lg text-sm font-medium transition-all ${loginMode === "employee"
                ? "bg-white text-blue-600 shadow-sm"
                : "text-gray-600 hover:text-gray-800"
                }`}
            >
              Employee
            </button>
          </div>

          {loginMode === "admin" ? (
            <>
              <div className="space-y-4">
                <div className="relative">
                  <FiMail className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Email"
                    type="email"
                    onChange={e => setEmail(e.target.value)}
                  />
                </div>
                <div className="relative">
                  <FiLock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="password"
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    placeholder="Password"
                    onChange={e => setPassword(e.target.value)}
                  />
                </div>
                <button
                  onClick={adminLogin}
                  className="w-full bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-3 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all transform hover:scale-[1.02]"
                >
                  Sign In
                </button>
              </div>
            </>
          ) : (
            <>
              <div className="space-y-4">
                <div className="relative">
                  <FiUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    className="w-full pl-10 pr-4 py-3 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500 focus:border-transparent"
                    placeholder="Employee Code"
                    onChange={e => setEmployeeCode(e.target.value)}
                  />
                </div>
                <button
                  onClick={employeeLogin}
                  className="w-full bg-gradient-to-r from-green-600 to-emerald-600 text-white py-3 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all transform hover:scale-[1.02]"
                >
                  Access Dashboard
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    );
  }

  if (authType === "employee") {
    const todoTasks = employeeTasks.filter(t => t.status === 'todo' || t.status === 'active');
    const inProgressTasks = employeeTasks.filter(t => t.status === 'inprogress');
    const doneTasks = employeeTasks.filter(t => t.status === 'done');

    return (
      <div className="min-h-screen bg-gray-50">
        <Toaster
          position="top-right"
          reverseOrder={false}
          gutter={8}
          containerClassName=""
          containerStyle={{}}
          toastOptions={{
            duration: 4000,
            style: {
              background: '#363636',
              color: '#fff',
              padding: '16px',
              borderRadius: '8px',
              fontSize: '14px',
              maxWidth: '400px',
            },
            success: {
              duration: 4000,
              style: {
                background: '#10b981',
                color: '#fff',
              },
              iconTheme: {
                primary: '#fff',
                secondary: '#10b981',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#ef4444',
                color: '#fff',
              },
              iconTheme: {
                primary: '#fff',
                secondary: '#ef4444',
              },
            },
          }}
        />
        <nav className="bg-white shadow-sm border-b border-gray-200 sticky top-0 z-10">
          <div className="px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between items-center h-16">
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                  <FiGrid className="text-white" />
                </div>
                <h1 className="text-xl font-semibold text-gray-800">Designer Portal</h1>
              </div>
              <div className="flex items-center gap-4">
                <div className="text-right">
                  <span className="text-sm text-gray-600 block">Welcome,</span>
                  <span className="text-sm font-semibold text-gray-800">{employeeName}</span>
                </div>
                <button
                  onClick={logout}
                  className="flex items-center gap-2 bg-red-50 text-red-600 px-4 py-2 rounded-lg hover:bg-red-100 transition-colors"
                >
                  <FiLogOut />
                  <span className="hidden sm:inline">Logout</span>
                </button>
              </div>
            </div>
          </div>
        </nav>

        <div className="flex flex-col lg:flex-row gap-6 p-4 sm:p-6">

          {/* LEFT SIDE */}
          <div className="flex-1">
            <div className="">
              {/* Summary Cards */}
              <div className="grid grid-cols-1 sm:grid-cols-4 gap-4 mb-6">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-600">Total Tasks</p>
                      <p className="text-2xl font-bold text-gray-800">{employeeTasks.length}</p>
                    </div>
                    <div className="w-10 h-10 bg-blue-100 rounded-lg flex items-center justify-center text-blue-600">
                      <FiGrid />
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-600">To Do</p>
                      <p className="text-2xl font-bold text-gray-800">{todoTasks.length}</p>
                    </div>
                    <div className="w-10 h-10 bg-yellow-100 rounded-lg flex items-center justify-center text-yellow-600">
                      <FiAlertCircle />
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-600">In Progress</p>
                      <p className="text-2xl font-bold text-gray-800">{inProgressTasks.length}</p>
                    </div>
                    <div className="w-10 h-10 bg-orange-100 rounded-lg flex items-center justify-center text-orange-600">
                      <FiClock />
                    </div>
                  </div>
                </div>
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4">
                  <div className="flex items-center justify-between">
                    <div>
                      <p className="text-sm text-gray-600">Completed</p>
                      <p className="text-2xl font-bold text-gray-800">{doneTasks.length}</p>
                    </div>
                    <div className="w-10 h-10 bg-green-100 rounded-lg flex items-center justify-center text-green-600">
                      <FiCheckCircle />
                    </div>
                  </div>
                </div>
              </div>

              {/* Task Board */}
              <h2 className="text-xl font-semibold text-gray-800 mb-4">My Tasks</h2>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                {/* Todo Column */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                  <div className="p-4 border-b border-gray-200 bg-yellow-50 rounded-t-xl">
                    <div className="flex items-center gap-2">
                      <FiAlertCircle className="text-yellow-600" />
                      <h3 className="font-semibold text-gray-800">To Do</h3>
                      <span className="ml-auto bg-yellow-200 text-yellow-800 px-2 py-1 rounded-full text-xs font-medium">
                        {todoTasks.length}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 space-y-3 max-h-[500px] overflow-y-auto">
                    {todoTasks.map(task => (
                      <div
                        key={task.id}
                        onClick={() => handleTaskClick(task)}
                        className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow cursor-pointer"
                      >
<span className="flex items-center justify-end gap-1">
  {task.client_status === 'new' && (
    <span className={`${styles.spanTextGreen600} span-text-green-600 font-medium`}>New</span>
  )}
  
  {task.client_status === 'urgent' && (
    <span className={`${styles.spanTextRed600} span-text-red-600 font-medium`}>Urgent</span>
  )}
  
  {task.client_status === 'old' && (
<span className={`${styles.spanTextYellow600} span-text-yellow-600 font-medium`}>Old</span>  )}
</span>
                        <p className="font-medium text-gray-800 mb-2">{task.title}</p>
                        <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mb-2">

                          {task.client_name && (
                            <span className="flex items-center gap-1 bg-purple-50 px-2 py-0.5 rounded-full text-xs">
                              <FiUser className="text-purple-500" size={12} />
                              <span className="text-purple-700">Client: {task.client_name}</span>
                            </span>
                          )}
                          {!task.client_name && task.lead_name && (
                            <span className="flex items-center gap-1 bg-orange-50 px-2 py-0.5 rounded-full text-xs">
                              <FiTrendingUp className="text-orange-500" size={12} />
                              <span className="text-orange-700">Lead: {task.lead_name}</span>
                            </span>
                          )}
                          <span className="flex items-center gap-1">
                            <FiBriefcase className="text-gray-400" size={14} />
                            {task.project_name}
                          </span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-xs px-2 py-1 rounded-full bg-yellow-100 text-yellow-800">
                            To Do
                          </span>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              updateEmployeeTaskStatus(task.id, 'inprogress');
                            }}
                            className="bg-blue-50 text-blue-600 px-3 py-1 rounded-lg text-xs font-medium hover:bg-blue-100 transition-colors"
                          >
                            Start
                          </button>
                        </div>
                      </div>
                    ))}
                    {todoTasks.length === 0 && (
                      <p className="text-center text-gray-400 text-sm py-8">No tasks to do</p>
                    )}
                  </div>
                </div>

                {/* In Progress Column */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                  <div className="p-4 border-b border-gray-200 bg-blue-50 rounded-t-xl">
                    <div className="flex items-center gap-2">
                      <FiClock className="text-blue-600" />
                      <h3 className="font-semibold text-gray-800">In Progress</h3>
                      <span className="ml-auto bg-blue-200 text-blue-800 px-2 py-1 rounded-full text-xs font-medium">
                        {inProgressTasks.length}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 space-y-3 max-h-[500px] overflow-y-auto">
                    {inProgressTasks.map(task => (
                      <div
                        key={task.id}
                        onClick={() => handleTaskClick(task)}
                        className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow cursor-pointer"
                      >
<span className="flex items-center justify-end gap-1">
  {task.client_status === 'new' && (
    <span className={`${styles.spanTextGreen600} span-text-green-600 font-medium`}>New</span>
  )}
  
  {task.client_status === 'urgent' && (
    <span className={`${styles.spanTextRed600} span-text-red-600 font-medium`}>Urgent</span>
  )}
  
  {task.client_status === 'old' && (
<span className={`${styles.spanTextYellow600} span-text-yellow-600 font-medium`}>Old</span>  )}
</span>
                        <p className="font-medium text-gray-800 mb-2">{task.title}</p>
                        <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mb-2">
                          {task.client_name && (
                            <span className="flex items-center gap-1 bg-purple-50 px-2 py-0.5 rounded-full text-xs">
                              <FiUser className="text-purple-500" size={12} />
                              <span className="text-purple-700">Client: {task.client_name}</span>
                            </span>
                          )}
                          {!task.client_name && task.lead_name && (
                            <span className="flex items-center gap-1 bg-orange-50 px-2 py-0.5 rounded-full text-xs">
                              <FiTrendingUp className="text-orange-500" size={12} />
                              <span className="text-orange-700">Lead: {task.lead_name}</span>
                            </span>
                          )}
                          <span className="flex items-center gap-1">
                            <FiBriefcase className="text-gray-400" size={14} />
                            {task.project_name}
                          </span>
                        </div>
                        <div className="flex items-center justify-between">
                          <span className="text-xs px-2 py-1 rounded-full bg-blue-100 text-blue-800">
                            In Progress
                          </span>
                          <button
                            onClick={(e) => {
                              e.stopPropagation();
                              updateEmployeeTaskStatus(task.id, 'done');
                            }}
                            className="bg-green-50 text-green-600 px-3 py-1 rounded-lg text-xs font-medium hover:bg-green-100 transition-colors"
                          >
                            Complete
                          </button>
                        </div>
                      </div>
                    ))}
                    {inProgressTasks.length === 0 && (
                      <p className="text-center text-gray-400 text-sm py-8">No tasks in progress</p>
                    )}
                  </div>
                </div>

                {/* Done Column */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200">
                  <div className="p-4 border-b border-gray-200 bg-green-50 rounded-t-xl">
                    <div className="flex items-center gap-2">
                      <FiCheckCircle className="text-green-600" />
                      <h3 className="font-semibold text-gray-800">Completed</h3>
                      <span className="ml-auto bg-green-200 text-green-800 px-2 py-1 rounded-full text-xs font-medium">
                        {doneTasks.length}
                      </span>
                    </div>
                  </div>
                  <div className="p-4 space-y-3 max-h-[500px] overflow-y-auto">
                    {doneTasks.map(task => (
                      <div
                        key={task.id}
                        onClick={() => handleTaskClick(task)}
                        className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow cursor-pointer opacity-75"
                      >
<span className="flex items-center justify-end gap-1">
  {task.client_status === 'new' && (
    <span className={`${styles.spanTextGreen600} span-text-green-600 font-medium`}>New</span>
  )}
  
  {task.client_status === 'urgent' && (
    <span className={`${styles.spanTextRed600} span-text-red-600 font-medium`}>Urgent</span>
  )}
  
  {task.client_status === 'old' && (
<span className={`${styles.spanTextYellow600} span-text-yellow-600 font-medium`}>Old</span>  )}
</span>
                        <p className="font-medium text-gray-800 mb-2">{task.title}</p>
                        <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mb-2">
                          {task.client_name && (
                            <span className="flex items-center gap-1 bg-purple-50 px-2 py-0.5 rounded-full text-xs">
                              <FiUser className="text-purple-500" size={12} />
                              <span className="text-purple-700">Client: {task.client_name}</span>
                            </span>
                          )}
                          {!task.client_name && task.lead_name && (
                            <span className="flex items-center gap-1 bg-orange-50 px-2 py-0.5 rounded-full text-xs">
                              <FiTrendingUp className="text-orange-500" size={12} />
                              <span className="text-orange-700">Lead: {task.lead_name}</span>
                            </span>
                          )}
                          <span className="flex items-center gap-1">
                            <FiBriefcase className="text-gray-400" size={14} />
                            {task.project_name}
                          </span>
                        </div>
                        <span className="text-xs px-2 py-1 rounded-full bg-green-100 text-green-800">
                          Completed
                        </span>
                      </div>
                    ))}
                    {doneTasks.length === 0 && (
                      <p className="text-center text-gray-400 text-sm py-8">No completed tasks</p>
                    )}
                  </div>
                </div>
              </div>

              {/* WhatsApp Sender Modal */}
              {showWhatsAppSender && selectedPosterForWhatsApp && (
                <WhatsAppSender
                  poster={selectedPosterForWhatsApp}
                  clients={clients.filter(c => c.phone)} // Only clients with phone numbers
                  base_url={base_url}
                  onClose={() => {
                    setShowWhatsAppSender(false);
                    setSelectedPosterForWhatsApp(null);
                  }}
                  onSuccess={() => {
                    fetchWhatsAppLogs(); // Refresh logs after sending
                  }}
                />
              )}
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="w-full lg:w-[420px] lg:sticky lg:top-6 h-fit">
            <div className="bg-white border rounded-lg overflow-hidden">
              {/* Collapsible Client Table */}
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Action</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Files</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Other Images</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Notes</th>
                        {/* <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Website</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Address</th>

                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plan</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Date</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source</th>                        
                        <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th> */}
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {clients.map((client) => (
                        <tr key={client.id} className="hover:bg-gray-50">
                          <td className="px-4 py-3 whitespace-nowrap">
                            <button
                              onClick={() => handleViewMore(client)}
                              className="text-blue-600 hover:text-blue-800 text-sm font-medium focus:outline-none"
                            >
                              <FiEye size={12} />
                            </button>
                          </td>
                          {/* Files Section */}
                          <td className="px-4 py-3 whitespace-nowrap">
                            <div className="flex flex-col gap-1">
                              {client.logo && (
                                <button
                                  onClick={() => downloadFile(client.logo, `${client.name}_logo${getFileExtension(client.logo)}`)}
                                  className="text-blue-600 hover:text-blue-800 text-xs flex items-center gap-1"
                                  title="Download Logo"
                                >
                                  <FiDownload size={12} />
                                  Logo
                                </button>
                              )}
                              {!client.logo}
                            </div>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <div className="flex flex-col gap-1">
                              {client.attachment ? (
                                <button
                                  onClick={() => downloadAttachmentFiles(client.attachment)}
                                  className="text-green-600 hover:text-green-800 text-xs flex items-center gap-1"
                                  title="Download Attachment"
                                >
                                  <FiDownload size={12} />
                                  Attachment
                                </button>
                              ) : (
                                "-"
                              )}
                            </div>
                          </td>
                          <td className="px-4 py-3 w-[200px] max-w-[200px] break-words whitespace-normal">
                            <div className="font-medium text-gray-900">
                              {client.name}
                            </div>
                          </td>

                          <td className="px-4 py-3 w-[300px] max-w-[300px] text-sm text-gray-500 break-words whitespace-normal">
                            {client.notes || '-'}
                          </td>
                          {/* <td className="px-4 py-3 whitespace-nowrap text-sm">
                            {client.email ? (
                              <a href={`mailto:${client.email}`} className="text-blue-600 hover:underline">
                                {client.email}
                              </a>
                            ) : '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                            {client.phone ? (
                              <a href={`tel:${client.phone}`} className="hover:text-blue-600">
                                {client.phone}
                              </a>
                            ) : '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm">
                            {client.website ? (
                              <a
                                href={client.website.startsWith('http') ? client.website : `https://${client.website}`}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="text-blue-600 hover:underline truncate max-w-[120px] block"
                              >
                                {client.website}
                              </a>
                            ) : '-'}
                          </td>
                          <td className="px-4 py-3 text-sm text-gray-500 max-w-[150px] truncate" title={client.address}>
                            {client.address || '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                            {client.plan_name || (client.plan_id ? `Plan ${client.plan_id}` : '-')}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                            {client.plan_price ? `₹${parseFloat(client.plan_price).toLocaleString()}` : '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                            {client.plan_duration || '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                            {client.payment_date ? new Date(client.payment_date).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            }) : '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap">
                            <span className={`px-2 py-1 text-xs font-semibold rounded-full ${client.status === 'active' ? 'bg-green-100 text-green-800' :
                              client.status === 'inactive' ? 'bg-red-100 text-red-800' :
                                'bg-yellow-100 text-yellow-800'
                              }`}>
                              {client.status || 'lead'}
                            </span>
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm">
                            {client.source ? (
                              <span className="px-2 py-1 bg-blue-100 text-blue-800 rounded-full text-xs">
                                {client.source}
                              </span>
                            ) : '-'}
                          </td>
                          <td className="px-4 py-3 whitespace-nowrap text-sm text-gray-500">
                            {client.created_at ? new Date(client.created_at).toLocaleDateString('en-US', {
                              year: 'numeric',
                              month: 'short',
                              day: 'numeric'
                            }) : '-'}
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Empty State */}
                  {clients.length === 0 && (
                    <div className="text-center py-12">
                      <FiUsers size={48} className="mx-auto text-gray-300 mb-3" />
                      <p className="text-gray-500 text-lg">No clients found</p>
                      <p className="text-gray-400 text-sm mt-1">Add your first client to get started</p>
                    </div>
                  )}
                   {/* Modal */}
                  <ClientDetailsModal
                    client={selectedClient}
                    isOpen={isModalOpen}
                    onClose={() => setIsModalOpen(false)}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  // Admin Panel
  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: <FiGrid /> },
    { id: 'sales', label: 'Sales', icon: <FiTrendingUp /> },    
    { id: 'clients', label: 'Clients', icon: <FiUsers /> },
    { id: 'invoices', label: 'Invoices', icon: <FiDollarSign /> },
    { id: 'campaigns', label: 'Campaigns', icon: <FiBriefcase /> },
    { id: 'employees', label: 'Employees', icon: <FiUsers /> },
    { id: 'payroll', label: 'Payroll', icon: <FiDollarSign /> },
    { id: 'projects', label: 'Projects', icon: <FiFolder /> },
    { id: 'plans', label: 'Plans', icon: <FiBriefcase /> }, // Add this line
    // { id: 'settings', label: 'Settings', icon: <FiSettings /> },
  ];

  const stats = [
    { label: 'Total Tasks', value: tasks.length, color: 'blue', icon: <FiCheckCircle /> },
    { label: 'Employees', value: employees.length, color: 'green', icon: <FiUsers /> },
    { label: 'Projects', value: projects.length, color: 'purple', icon: <FiFolder /> },
    { label: 'Total Leads', value: leads.length, color: 'orange', icon: <FiTrendingUp /> },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <Toaster
        position="top-right"
        reverseOrder={false}
        gutter={8}
        containerClassName=""
        containerStyle={{}}
        toastOptions={{
          duration: 4000,
          style: {
            background: '#363636',
            color: '#fff',
            padding: '16px',
            borderRadius: '8px',
            fontSize: '14px',
            maxWidth: '400px',
          },
          success: {
            duration: 4000,
            style: {
              background: '#10b981',
              color: '#fff',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#10b981',
            },
          },
          error: {
            duration: 5000,
            style: {
              background: '#ef4444',
              color: '#fff',
            },
            iconTheme: {
              primary: '#fff',
              secondary: '#ef4444',
            },
          },
        }}
      />
      
      {/* Mobile Header */}
      <div className="lg:hidden bg-white border-b border-gray-200 fixed top-0 left-0 right-0 z-20">
        <div className="flex items-center justify-between px-4 h-16">
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
              <FiGrid className="text-white" />
            </div>
            <h1 className="text-xl font-semibold text-gray-800">Admin Panel</h1>
          </div>
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="p-2 hover:bg-gray-100 rounded-lg"
          >
            {mobileMenuOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden fixed inset-0 z-10 bg-black bg-opacity-50" onClick={() => setMobileMenuOpen(false)}>
          <div className="fixed left-0 top-16 bottom-0 w-64 bg-white shadow-xl" onClick={e => e.stopPropagation()}>
            <nav className="p-4">
              {menuItems.map(item => (
                <button
                  key={item.id}
                  onClick={() => {
                    setActivePage(item.id);
                    setMobileMenuOpen(false);
                  }}
                  className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg mb-1 transition-colors ${activePage === item.id
                    ? 'bg-blue-50 text-blue-600'
                    : 'text-gray-600 hover:bg-gray-50'
                    }`}
                >
                  {item.icon}
                  <span>{item.label}</span>
                </button>
              ))}
              <button
                onClick={logout}
                className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 mt-4"
              >
                <FiLogOut />
                <span>Logout</span>
              </button>
            </nav>
          </div>
        </div>
      )}

      {/* Desktop Sidebar */}
      <div className="hidden lg:fixed lg:inset-y-0 lg:flex lg:w-64 lg:flex-col">
        <div className="flex flex-col flex-1 min-h-0 bg-white border-r border-gray-200">
          <div className="flex items-center h-16 px-4 border-b border-gray-200">
            <div className="flex items-center gap-3">
              <div className="w-8 h-8 bg-gradient-to-r from-blue-600 to-indigo-600 rounded-lg flex items-center justify-center">
                <FiGrid className="text-white" />
              </div>
              <h1 className="text-xl font-semibold text-gray-800">Admin Panel</h1>
            </div>
          </div>
          <nav className="flex-1 px-2 py-4 space-y-1">
            {menuItems.map(item => (
              <button
                key={item.id}
                onClick={() => setActivePage(item.id)}
                className={`w-full flex items-center gap-3 px-4 py-3 rounded-lg transition-colors ${activePage === item.id
                  ? 'bg-blue-50 text-blue-600'
                  : 'text-gray-600 hover:bg-gray-50'
                  }`}
              >
                {item.icon}
                <span>{item.label}</span>
              </button>
            ))}
          </nav>
          <div className="p-4 border-t border-gray-200">
            <button
              onClick={logout}
              className="w-full flex items-center gap-3 px-4 py-3 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
            >
              <FiLogOut />
              <span>Logout</span>
            </button>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="lg:pl-64">
        <main className="pt-16 lg:pt-0 min-h-screen">
          <div className="p-4 sm:p-6 lg:p-8">
            {/* Stats Cards */}
            {activePage === 'dashboard' && (
              <>
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
                  {stats.map((stat, index) => (
                    <div key={index} className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                      <div className="flex items-center justify-between">
                        <div>
                          <p className="text-sm text-gray-600 mb-1">{stat.label}</p>
                          <p className="text-3xl font-bold text-gray-800">{stat.value}</p>
                        </div>
                        <div className={`w-12 h-12 bg-${stat.color}-100 rounded-lg flex items-center justify-center text-${stat.color}-600`}>
                          {stat.icon}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 mb-6 sm:mb-8">
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">Today's Tasks</p>
            <p className="text-3xl font-bold text-green-600">{dashboardSummary.today_tasks}</p>
          </div>
          <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center text-green-600">
            <FiCalendar size={24} />
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">Completed Tasks</p>
            <p className="text-3xl font-bold text-purple-600">{dashboardSummary.completed_tasks}</p>
          </div>
          <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center text-purple-600">
            <FiTrendingUp size={24} />
          </div>
        </div>
      </div>
      
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-600 mb-1">Active Employees</p>
            <p className="text-3xl font-bold text-orange-600">{employeeTaskStats.length}</p>
          </div>
          <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center text-orange-600">
            <FiUsers size={24} />
          </div>
        </div>
      </div>
    </div>

    {/* Employee Performance Table */}
    <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden mb-6">
      <div className="p-6 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <div>
            <h2 className="text-xl font-semibold text-gray-800">Employee Performance</h2>
            <p className="text-sm text-gray-500 mt-1">Task completion metrics by employee</p>
          </div>
          
          {/* Filter Buttons */}
          <div className="flex gap-2">
            <button
              onClick={() => setStatsDateRange('all')}
              className={`px-3 py-1.5 text-xs rounded-lg transition-all ${
                statsDateRange === 'all' 
                  ? 'bg-blue-600 text-white shadow-md' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              All Time
            </button>
            <button
              onClick={() => setStatsDateRange('today')}
              className={`px-3 py-1.5 text-xs rounded-lg transition-all ${
                statsDateRange === 'today' 
                  ? 'bg-green-600 text-white shadow-md' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Today
            </button>
            <button
              onClick={() => setStatsDateRange('7days')}
              className={`px-3 py-1.5 text-xs rounded-lg transition-all ${
                statsDateRange === '7days' 
                  ? 'bg-purple-600 text-white shadow-md' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Last 7 Days
            </button>
            <button
              onClick={() => setStatsDateRange('30days')}
              className={`px-3 py-1.5 text-xs rounded-lg transition-all ${
                statsDateRange === '30days' 
                  ? 'bg-indigo-600 text-white shadow-md' 
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Last 30 Days
            </button>
          </div>
        </div>
      </div>
      
      <div className="overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200">
          <thead className="bg-gray-50">
            <tr>
              <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Total</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Today</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Yesterday</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Last 7 Days</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Last 30 Days</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Todo</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Progress</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Done</th>
              <th className="px-6 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider">Rate</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {employeeTaskStats
              .filter(emp => {
                if (statsDateRange === 'today') return parseInt(emp.today_count) > 0;
                if (statsDateRange === '7days') return parseInt(emp.last_7_days_count) > 0;
                if (statsDateRange === '30days') return parseInt(emp.last_30_days_count) > 0;
                return true;
              })
              .map((emp) => {
                const completionRate = parseFloat(emp.completion_rate);
                return (
                  <tr key={emp.id} className="hover:bg-gray-50 transition-colors cursor-pointer" onClick={() => handleEmployeeClick(emp)}>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center">
                        <div className="flex-shrink-0 h-10 w-10">
                          <div className="h-10 w-10 rounded-full bg-gradient-to-r from-blue-500 to-indigo-500 flex items-center justify-center text-white font-semibold">
                            {emp.name.charAt(0).toUpperCase()}
                          </div>
                        </div>
                        <div className="ml-4">
                          <div className="text-sm font-medium text-gray-900">{emp.name}</div>
                          <div className="text-xs text-gray-500">{emp.code || 'No code'}</div>
                        </div>
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className="text-sm font-semibold text-gray-800">{emp.total_tasks}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        parseInt(emp.today_count) > 0 ? 'bg-green-100 text-green-800' : 'bg-gray-100 text-gray-500'
                      }`}>
                        {emp.today_count || 0}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium ${
                        parseInt(emp.yesterday_count) > 0 ? 'bg-blue-100 text-blue-800' : 'bg-gray-100 text-gray-500'
                      }`}>
                        {emp.yesterday_count || 0}
                      </span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-purple-600 font-medium">
                      {emp.last_7_days_count || 0}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center text-indigo-600 font-medium">
                      {emp.last_30_days_count || 0}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className="text-yellow-600 font-medium">{emp.todo_count || 0}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className="text-blue-600 font-medium">{emp.inprogress_count || 0}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-center">
                      <span className="text-green-600 font-semibold">{emp.done_count || 0}</span>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap">
                      <div className="flex items-center gap-2">
                        <div className="flex-1 bg-gray-200 rounded-full h-2 min-w-[60px]">
                          <div 
                            className={`rounded-full h-2 transition-all duration-500 ${
                              completionRate >= 70 ? 'bg-green-600' : 
                              completionRate >= 40 ? 'bg-yellow-600' : 'bg-red-600'
                            }`}
                            style={{ width: `${completionRate}%` }}
                          />
                        </div>
                        <span className={`text-xs font-semibold min-w-[45px] ${
                          completionRate >= 70 ? 'text-green-600' : 
                          completionRate >= 40 ? 'text-yellow-600' : 'text-red-600'
                        }`}>
                          {completionRate}%
                        </span>
                      </div>
                    </td>
                  </tr>
                );
              })}
            {employeeTaskStats.length === 0 && (
              <tr>
                <td colSpan="10" className="px-6 py-8 text-center text-gray-500">
                  No task data available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
                {/* Add Task Form */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6 mb-6">
                  <h2 className="text-lg font-semibold text-gray-800 mb-4">Create New Task</h2>
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
                    <input
                      value={title}
                      onChange={e => setTitle(e.target.value)}
                      placeholder="Task title"
                      className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <select
                      value={employeeId}
                      onChange={e => setEmployeeId(e.target.value)}
                      className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value="">Select Employee</option>
                      {employees.map(emp => (
                        <option key={emp.id} value={emp.id}>{emp.name}</option>
                      ))}
                    </select>
                    <select
                      value={projectId}
                      onChange={e => setProjectId(e.target.value)}
                      className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value="">Select Project</option>
                      {projects.map(pro => (
                        <option key={pro.id} value={pro.id}>{pro.name}</option>
                      ))}
                    </select>
                    <select
                      value={leadId}
                      onChange={e => setLeadId(e.target.value)}
                      className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    >
                      <option value="">Select Lead</option>
                      {leads.map(lead => (
                        <option key={lead.id} value={lead.id}>
                          {lead.name} - {lead.company}
                        </option>
                      ))}
                    </select>
                    <button
                      onClick={addTask}
                      className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-2 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all flex items-center justify-center gap-2"
                    >
                      <FiPlus />
                      Add Task
                    </button>
                  </div>
                </div>

                {/* Task Board */}
<div className="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-6">
  {['todo', 'inprogress', 'done'].map((status, index) => (
    <div
      key={status}
      className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
    >
      <div className={`p-4 border-b ${getStatusColor(status)}`}>
        <div className="flex items-center gap-2">
          {getStatusIcon(status)}
          <h3 className="font-semibold capitalize">{status}</h3>
          <span className="ml-auto bg-white/50 px-2 py-1 rounded-full text-xs font-medium">
            {tasks.filter(t => t.status === status).length}
          </span>
        </div>
      </div>
      <div className="p-4 space-y-3 max-h-[500px] overflow-y-auto">
        {tasks.filter(t => t.status === status).map(task => (
          <div
            key={task.id}
            className="bg-gray-50 p-4 rounded-lg border border-gray-200 hover:shadow-md transition-shadow"
          >
            

            <div onClick={() => setSelectedLead(task)}>
              <span className="flex items-center justify-end gap-1">
                {task.client_status === 'new' && (
                  <span className={`${styles.spanTextGreen600} span-text-green-600 font-medium`}>New</span>
                )}
                
                {task.client_status === 'urgent' && (
                  <span className={`${styles.spanTextRed600} span-text-red-600 font-medium`}>Urgent</span>
                )}
                
                {task.client_status === 'old' && (
                  <span className={`${styles.spanTextYellow600} span-text-yellow-600 font-medium`}>Old</span>
                )}
              </span>
              <p className="font-medium text-gray-800 mb-2">{task.title}</p>
              <div className="flex flex-wrap items-center gap-2 text-sm text-gray-600 mb-2">
                <span className="flex items-center gap-1">
                  <FiUser className="text-gray-400" size={14} />
                  {task.employee_name}
                </span>
                <span className="flex items-center gap-1">
                  {task.client_name ? (
                    <>
                      <FiUser className="text-purple-400" size={14} />
                      <span className="text-purple-600">Client: {task.client_name}</span>
                    </>
                  ) : (
                    <>
                      <FiTrendingUp className="text-orange-400" size={14} />
                      <span className="text-orange-600">Lead: {task.lead_name}</span>
                    </>
                  )}
                </span>
                <span className="flex items-center gap-1">
                  <FiFolder className="text-gray-400" size={14} />
                  {task.project_name} 
                </span>
                <span className="flex items-center gap-1">
                  {new Date(task.created_at).toLocaleDateString('en-GB')}
                </span>
              </div>
              <div className="flex items-center justify-between">
                <span className={`text-xs px-2 py-1 rounded-full ${getStatusBadge(status)}`}>
                  {status}
                </span>
                {status !== 'done' && (
                  <button
                    onClick={() => updateStatus(task.id, status === 'todo' ? 'inprogress' : 'done')}
                    className="bg-blue-50 text-blue-600 px-3 py-1 rounded-lg text-xs font-medium hover:bg-blue-100 transition-colors flex items-center gap-1"
                  >
                    Move {status === 'todo' ? '→' : '✓'}
                  </button>
                )}
                <button
                onClick={(e) => {
                  e.stopPropagation(); // Prevent triggering the parent onClick
                  handleDeleteTask(task.id);
                }}
                className="text-red-500 hover:text-red-700 transition-colors p-1 rounded-full hover:bg-red-50"
                title="Delete task"
              >
                <FiTrash2 size={16} />
              </button>
              </div>
            </div>
          </div>
        ))}
        {tasks.filter(t => t.status === status).length === 0 && (
          <p className="text-center text-gray-400 text-sm py-8">No tasks</p>
        )}
      </div>
    </div>
  ))}
</div>
              </>
            )}
            {selectedLead && (
              <div className="fixed right-0 top-0 h-screen w-80 bg-white border-l shadow-lg z-30 overflow-y-auto">
                <div className="p-6">
                  <div className="flex justify-between items-center mb-6">
                    <h3 className="font-semibold text-lg">Task Details</h3>
                    <button
                      onClick={() => setSelectedLead(null)}
                      className="text-gray-400 hover:text-gray-600"
                    >
                      <FiX size={20} />
                    </button>
                  </div>
                  <div className="space-y-4">
                    <div>
                      <label className="text-xs text-gray-500 uppercase">Task</label>
                      <p className="font-medium">{selectedLead.title}</p>
                    </div>
                    <div>
                      <label className="text-xs text-gray-500 uppercase">Assigned Employee</label>
                      <p>{selectedLead.employee_name}</p>
                    </div>
                    <div>
                      <label className="text-xs text-gray-500 uppercase">Project</label>
                      <p>{selectedLead.project_name}</p>
                    </div>
                    <div>
                      <label className="text-xs text-gray-500 uppercase">Status</label>
                      <span className={`inline-block mt-1 text-xs px-2 py-1 rounded-full ${getStatusBadge(selectedLead.status)}`}>
                        {selectedLead.status}
                      </span>
                    </div>
                    <hr />
                    <div>
                      <label className="text-xs text-gray-500 uppercase">Contact Type</label>
                      <p className="flex items-center gap-1 mt-1">
                        {selectedLead.client_name ? (
                          <>
                            <FiUser className="text-purple-500" size={14} />
                            <span>Client: {selectedLead.client_name}</span>
                          </>
                        ) : (
                          <>
                            <FiTrendingUp className="text-orange-500" size={14} />
                            <span>Lead: {selectedLead.lead_name}</span>
                          </>
                        )}
                      </p>
                    </div>
                    {selectedLead.client_name && (
                      <>
                        <div>
                          <label className="text-xs text-gray-500 uppercase">Client Company</label>
                          <p>{selectedLead.client_company}</p>
                        </div>
                        <div>
                          <label className="text-xs text-gray-500 uppercase">Client Email</label>
                          <p>{selectedLead.client_email}</p>
                        </div>
                        <div>
                          <label className="text-xs text-gray-500 uppercase">Client Phone</label>
                          <p>{selectedLead.client_phone}</p>
                        </div>
                      </>
                    )}
                    {selectedLead.lead_name && (
                      <>
                        <div>
                          <label className="text-xs text-gray-500 uppercase">Lead Company</label>
                          <p>{selectedLead.lead_company}</p>
                        </div>
                        <div>
                          <label className="text-xs text-gray-500 uppercase">Lead Email</label>
                          <p>{selectedLead.lead_email}</p>
                        </div>
                        <div>
                          <label className="text-xs text-gray-500 uppercase">Lead Phone</label>
                          <p>{selectedLead.lead_phone}</p>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            )}

            {/* Sales Section */}
            {activePage === 'sales' && (
              <div className="space-y-6">
                {/* Sales Header */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  <h2 className="text-2xl font-bold text-gray-800">Sales Management</h2>
                  <div className="flex gap-3">
                    <button
                      onClick={async () => {
                        try {
                          const response = await fetch(
                            "https://digitalmarketingwala.co.in/task-api/import_leads.php",
                            {
                              method: "GET", // ya POST agar API me hai
                              credentials: "include", // session ke liye important
                            }
                          );

                          const data = await response.json();
                          console.log(data);

                          alert("Leads imported successfully 🚀");
                        } catch (error) {
                          console.error(error);
                          alert("Error importing leads ❌");
                        }
                      }}
                      className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center gap-2"
                    >
                      <FiPlus />
                      Import leads
                    </button>
                    <button
                      onClick={() => {
                        setShowAddLead(true);
                        setShowAddFollowup(false);
                      }}
                      className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center gap-2"
                    >
                      <FiPlus />
                      Add Lead
                    </button>
                    <button
                      onClick={() => {
                        setShowAddFollowup(true);
                        setShowAddLead(false);
                        setSelectedLead(null);
                      }}
                      className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-4 py-2 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all flex items-center gap-2"
                    >
                      <FiPlus />
                      Add Followup
                    </button>
                  </div>
                </div>

                {/* Lead Stats */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
                  {['new', 'contacted', 'qualified', 'proposal', 'negotiation', 'won'].map(status => (
                    <div key={status} className="bg-white rounded-lg shadow-sm border border-gray-200 p-3">
                      <p className="text-xs text-gray-500 capitalize">{status}</p>
                      <p className="text-xl font-bold text-gray-800">
                        {leads.filter(l => l.status === status).length}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Add Lead Modal */}
                {showAddLead && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] flex flex-col">
                      {/* Fixed Header */}
                      <div className="p-6 pb-2">
                        <h3 className="text-xl font-bold text-gray-800">Add New Lead</h3>
                      </div>

                      {/* Scrollable Content */}
                      <div className="flex-1 overflow-y-auto px-6">
                        <div className="space-y-4 pb-4">
                          <input
                            type="text"
                            placeholder="Name *"
                            value={leadForm.name}
                            onChange={e => setLeadForm({ ...leadForm, name: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          />
                          <input
                            type="text"
                            placeholder="Company"
                            value={leadForm.company}
                            onChange={e => setLeadForm({ ...leadForm, company: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          />
                          <input
                            type="email"
                            placeholder="Email"
                            value={leadForm.email}
                            onChange={e => setLeadForm({ ...leadForm, email: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          />
                          <input
                            type="tel"
                            placeholder="Phone"
                            value={leadForm.phone}
                            onChange={e => setLeadForm({ ...leadForm, phone: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          />
                          <select
                            value={leadForm.status}
                            onChange={e => setLeadForm({ ...leadForm, status: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="new">New</option>
                            <option value="contacted">Contacted</option>
                            <option value="qualified">Qualified</option>
                            <option value="proposal">Proposal</option>
                            <option value="negotiation">Negotiation</option>
                            <option value="won">Won</option>
                            <option value="lost">Lost</option>
                          </select>
                          <select
                            value={leadForm.source}
                            onChange={e => setLeadForm({ ...leadForm, source: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="website">Website</option>
                            <option value="referral">Referral</option>
                            <option value="social">Social Media</option>
                            <option value="call">Phone Call</option>
                            <option value="email">Email</option>
                            <option value="other">Other</option>
                          </select>
                          <textarea
                            placeholder="Notes"
                            value={leadForm.notes}
                            onChange={e => setLeadForm({ ...leadForm, notes: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                            rows="3"
                          />
                          <div>
                            <label className="block text-sm text-gray-600 mb-1">Payment Date</label>
                            <input
                              type="date"
                              placeholder="Payment Date *"
                              value={leadForm.payment_date}
                              onChange={e => setLeadForm({ ...leadForm, payment_date: e.target.value })}
                              className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                            />
                          </div>
                        </div>
                      </div>

                      {/* Fixed Footer with Buttons */}
                      <div className="p-6 pt-2 border-t border-gray-100">
                        <div className="flex gap-3">
                          <button
                            onClick={addLead}
                            className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700"
                          >
                            Add Lead
                          </button>
                          <button
                            onClick={() => setShowAddLead(false)}
                            className="flex-1 bg-gray-100 text-gray-600 py-2 rounded-lg font-medium hover:bg-gray-200"
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Add Followup Modal */}
                {showAddFollowup && (
                  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
                    <div className="bg-white rounded-xl shadow-xl max-w-md w-full p-6 max-h-[90vh] flex flex-col">
                      <h3 className="text-xl font-bold text-gray-800 mb-4">Add Follow-up</h3>
                      <div className="flex-1 overflow-y-auto px-6">
                        <div className="space-y-4">
                          <select
                            value={followupForm.lead_id}
                            onChange={e => setFollowupForm({ ...followupForm, lead_id: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="">Select Lead *</option>
                            {leads.map(lead => (
                              <option key={lead.id} value={lead.id}>{lead.name} - {lead.company}</option>
                            ))}
                          </select>
                          <div className="grid grid-cols-2 gap-4">
                            <input
                              type="date"
                              value={followupForm.followup_date}
                              onChange={e => setFollowupForm({ ...followupForm, followup_date: e.target.value })}
                              className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                              placeholder="Date *"
                            />
                            <input
                              type="time"
                              value={followupForm.followup_time}
                              onChange={e => setFollowupForm({ ...followupForm, followup_time: e.target.value })}
                              className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                              placeholder="Time"
                            />
                          </div>
                          <select
                            value={followupForm.status}
                            onChange={e => setFollowupForm({ ...followupForm, status: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                          >
                            <option value="pending">Pending</option>
                            <option value="completed">Completed</option>
                            <option value="cancelled">Cancelled</option>
                            <option value="rescheduled">Rescheduled</option>
                          </select>
                          <textarea
                            placeholder="Notes"
                            value={followupForm.notes}
                            onChange={e => setFollowupForm({ ...followupForm, notes: e.target.value })}
                            className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                            rows="3"
                          />
                          <div className="border-t border-gray-200 pt-4">
                            <p className="text-sm font-medium text-gray-700 mb-2">Next Follow-up</p>
                            <div className="grid grid-cols-2 gap-4">
                              <input
                                type="date"
                                value={followupForm.next_followup_date}
                                onChange={e => setFollowupForm({ ...followupForm, next_followup_date: e.target.value })}
                                className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                                placeholder="Next Date"
                              />
                              <input
                                type="time"
                                value={followupForm.next_followup_time}
                                onChange={e => setFollowupForm({ ...followupForm, next_followup_time: e.target.value })}
                                className="px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500"
                                placeholder="Next Time"
                              />
                            </div>
                          </div>
                          <div className="flex gap-3 pt-4">
                            <button
                              onClick={addFollowup}
                              className="flex-1 bg-gradient-to-r from-blue-600 to-indigo-600 text-white py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700"
                            >
                              Add Follow-up
                            </button>
                            <button
                              onClick={() => setShowAddFollowup(false)}
                              className="flex-1 bg-gray-100 text-gray-600 py-2 rounded-lg font-medium hover:bg-gray-200"
                            >
                              Cancel
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Leads and Followups Grid */}
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Leads List */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                    <div className="p-4 border-b border-gray-200 bg-gray-50">
                      <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                        <FiUsers />
                        Leads
                      </h3>
                    </div>
                    <div className="divide-y divide-gray-200 max-h-[600px] overflow-y-auto">
                      {leads.map(lead => (
                        <div key={lead.id} className="p-4 hover:bg-gray-50 transition-colors">
                          <div className="flex justify-between items-start mb-2">
                            <div>
                              <h4 className="font-medium text-gray-800">{lead.name}</h4>
                              <p className="text-sm text-gray-600">{lead.company}</p>
                            </div>
                            <span className={`text-xs px-2 py-1 rounded-full ${getLeadStatusColor(lead.status)}`}>
                              {lead.status}
                            </span>
                          </div>
                          <div className="flex flex-wrap gap-3 text-sm text-gray-600 mb-2">
                            {lead.email && (
                              <span className="flex items-center gap-1">
                                <FiMail size={12} />
                                {lead.email}
                              </span>
                            )}
                            {lead.phone && (
                              <span className="flex items-center gap-1">
                                <FiPhone size={12} />
                                {lead.phone}
                              </span>
                            )}
                          </div>
                          <p className="text-xs text-gray-500 mb-2">Source: {lead.source}</p>
                          <div className="flex justify-between items-center">
                            <div className="flex gap-2">
                              <button
                                onClick={() => {
                                  setSelectedLead(lead);
                                  setFollowupForm({ ...followupForm, lead_id: lead.id });
                                  setShowAddFollowup(true);
                                }}
                                className="text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1"
                              >
                                <FiPlus size={12} />
                                Add Follow-up
                              </button>
                              <button
                                onClick={() => {
                                  setSelectedLeadForConversion(lead);
                                  setConversionForm({
                                    name: lead.name || "",
                                    company: lead.company || "",
                                    email: lead.email || "",
                                    phone: lead.phone || "",
                                    website: "",
                                    address: "",
                                    plan_id: "",
                                    payment_date: ""
                                  });
                                  setShowConvertLeadModal(true);
                                }}
                                className="text-xs text-green-600 hover:text-green-800 flex items-center gap-1"
                              >
                                <FiRefreshCw size={12} />
                                Convert
                              </button>
                            </div>
                            <div className="flex gap-2">
                              <button
                                onClick={() => updateLead(lead.id, { status: 'qualified' })}
                                className="text-xs text-green-600 hover:text-green-800"
                              >
                                Qualify
                              </button>
                              <button
                                onClick={() => deleteLead(lead.id)}
                                className="text-xs text-red-600 hover:text-red-800"
                              >
                                Delete
                              </button>
                            </div>
                          </div>
                        </div>
                      ))}
                      {leads.length === 0 && (
                        <div className="p-8 text-center text-gray-500">
                          No leads found. Add your first lead!
                        </div>
                      )}
                    </div>
                  </div>

                  {/* Followups List */}
                  <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                    <div className="p-4 border-b border-gray-200 bg-gray-50">
                      <h3 className="font-semibold text-gray-800 flex items-center gap-2">
                        <FiCalendar />
                        Follow-ups
                      </h3>
                    </div>
                    <div className="divide-y divide-gray-200 max-h-[600px] overflow-y-auto">
                      {followups.map(followup => {
                        const lead = leads.find(l => l.id == followup.lead_id);
                        return (
                          <div key={followup.id} className="p-4 hover:bg-gray-50 transition-colors">
                            <div className="flex justify-between items-start mb-2">
                              <div>
                                <h4 className="font-medium text-gray-800">{lead?.name || 'Unknown Lead'}</h4>
                                <p className="text-sm text-gray-600">{lead?.company}</p>
                              </div>
                              <span className={`text-xs px-2 py-1 rounded-full ${getFollowupStatusColor(followup.status)}`}>
                                {followup.status}
                              </span>
                            </div>
                            <div className="flex items-center gap-4 text-sm mb-2">
                              <span className="flex items-center gap-1 text-gray-600">
                                <FiCalendar size={12} />
                                {followup.followup_date}
                              </span>
                              {followup.followup_time && (
                                <span className="flex items-center gap-1 text-gray-600">
                                  <FiClock size={12} />
                                  {followup.followup_time}
                                </span>
                              )}
                            </div>
                            {followup.notes && (
                              <p className="text-sm text-gray-600 mb-2 bg-gray-50 p-2 rounded">
                                {followup.notes}
                              </p>
                            )}
                            {followup.next_followup_date && (
                              <div className="text-xs text-blue-600 flex items-center gap-1 mt-2">
                                <FiArrowRight />
                                Next: {followup.next_followup_date} {followup.next_followup_time}
                              </div>
                            )}
                            <div className="flex justify-end gap-2 mt-2">
                              <button
                                onClick={() => {
                                  setEditingFollowup(followup);
                                  setFollowupForm({
                                    lead_id: followup.lead_id,
                                    followup_date: followup.followup_date,
                                    followup_time: followup.followup_time || '',
                                    status: followup.status,
                                    notes: followup.notes || '',
                                    next_followup_date: followup.next_followup_date || '',
                                    next_followup_time: followup.next_followup_time || ''
                                  });
                                }}
                                className="text-xs text-blue-600 hover:text-blue-800"
                              >
                                <FiEdit2 size={14} />
                              </button>
                              <button
                                onClick={() => deleteFollowup(followup.id)}
                                className="text-xs text-red-600 hover:text-red-800"
                              >
                                <FiTrash2 size={14} />
                              </button>
                            </div>
                          </div>
                        );
                      })}
                      {followups.length === 0 && (
                        <div className="p-8 text-center text-gray-500">
                          No follow-ups scheduled.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Clients Section */}
            {activePage === 'clients' && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h2 className="text-xl font-semibold mb-4">Clients</h2>
                {/* Employee Assignment Modal */}
                {showEmployeeModal && (
                  <div className="fixed inset-0 bg-gray-600 bg-opacity-50 overflow-y-auto h-full w-full z-50">
                    <div className="relative top-20 mx-auto p-5 border w-96 shadow-lg rounded-lg bg-white">
                      <div className="flex justify-between items-center mb-4">
                        <h3 className="text-lg font-semibold text-gray-900">
                          Assign Employee to {selectedClientForAssignment?.name}
                        </h3>
                        <button
                          onClick={() => {
                            setShowEmployeeModal(false);
                            setSelectedClientForAssignment(null);
                            setSelectedEmployeeId('');
                          }}
                          className="text-gray-400 hover:text-gray-600"
                        >
                          <FiX size={20} />
                        </button>
                      </div>
		      <div className="mb-4">
  {/* Status Tabs */}
  <div className="flex gap-2 border-b border-gray-200">
    <button
      onClick={() => setActiveStatusTab('new')}
      className={`px-4 py-2 text-sm font-medium transition-colors relative ${
        activeStatusTab === 'new'
          ? 'text-green-600 border-b-2 border-green-600'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      New
    </button>
    <button
      onClick={() => setActiveStatusTab('urgent')}
      className={`px-4 py-2 text-sm font-medium transition-colors relative ${
        activeStatusTab === 'urgent'
          ? 'text-red-600 border-b-2 border-red-600'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      Urgent
    </button>
    <button
      onClick={() => setActiveStatusTab('old')}
      className={`px-4 py-2 text-sm font-medium transition-colors relative ${
        activeStatusTab === 'old'
          ? 'text-yellow-600 border-b-2 border-yellow-600'
          : 'text-gray-500 hover:text-gray-700'
      }`}
    >
      Old
    </button>
  </div>
</div>

                      <div className="mb-4">
                        <label className="block text-sm font-medium text-gray-700 mb-2">
                          Select Employee
                        </label>
                        {/* Using your existing employee select style */}
                        <select
                          value={selectedEmployeeId}
                          onChange={(e) => setSelectedEmployeeId(e.target.value)}
                          className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent"
                        >
                          <option value="">Select Employee</option>
                          {employees.map(emp => (
                            <option key={emp.id} value={emp.id}>{emp.name}</option>
                          ))}
                        </select>
                      </div>

                      <div className="flex justify-end gap-2">
                        <button
                          onClick={() => {
                            setShowEmployeeModal(false);
                            setSelectedClientForAssignment(null);
                            setSelectedEmployeeId('');
                          }}
                          className="px-4 py-2 text-gray-600 hover:text-gray-800 border border-gray-200 rounded-lg hover:bg-gray-50"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={handleAssignEmployee}
                          disabled={!selectedEmployeeId}
                          className="px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
                        >
                          <FiUserCheck size={18} />
                          Assign
                        </button>
                      </div>
                    </div>
                  </div>
                )}
                {showAttachmentModal && (
                  <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50">
                    <div className="bg-white rounded-lg p-6 max-w-3xl w-full relative">

                      <button
                        onClick={() => setShowAttachmentModal(false)}
                        className="absolute top-3 right-3 text-gray-600 hover:text-black"
                      >
                        ✕
                      </button>

                      <h2 className="text-lg font-semibold mb-4">Attachments</h2>

                      <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
                        {modalImages.map((img, i) => (
                          <img
                            key={i}
                            src={`${base_url}/${img}`}
                            className="w-full h-40 object-cover rounded"
                            alt="attachment"
                          />
                        ))}
                      </div>

                    </div>
                  </div>
                )}
                {/* Clients Table with all fields */}
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
<th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Logo</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Images</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Date</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Website</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plan</th>
                        
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Assigned Employee</th>
                        
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {(Array.isArray(clients) ? clients : []).map((client, index) => (
                      <tr key={`${client.id}-${index}`} className="hover:bg-gray-50">
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{client.id}</td>
                                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button
                              onClick={() => downloadInvoice(client.id)}
                              className="text-green-600 hover:text-green-900 mr-3"
                              title="Download Invoice"
                            >
                              ⬇️
                            </button>
                            <button
                              onClick={() => {
                                setSelectedClientForAssignment(client);
                                setShowEmployeeModal(true);
                              }}
                              className="text-purple-600 hover:text-purple-900 mr-3"
                              title="Assign Employee"
                            >
                              <FiUserPlus size={18} />
                            </button>
                            <button
                              onClick={() => {
                                setSelectedPosterForWhatsApp(posters);
                                setShowWhatsAppSender(true);
                              }}
                              className="text-green-600 hover:text-green-900 mr-3"
                              title="Send via WhatsApp"
                            >
                              <FiMessageCircle size={18} />
                            </button>
                            <button
                              onClick={() => openEditModal(client)}
                              className="text-blue-600 hover:text-blue-900 mr-3"
                            >
                              Edit
                            </button>
                            <button
                              onClick={() => handleDeleteClient(client.id)}
                              className="text-red-600 hover:text-red-900"
                            >
                              Delete
                            </button>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            {client.logo ? (
                              <img src={`${base_url}/${client.logo}`} alt={client.name} className="h-10 w-10 rounded-full object-cover" />
                            ) : (
                              <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                                <span className="text-xs text-gray-500">No logo</span>
                              </div>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            {client.attachment ? (() => {
                              const attachments = client.attachment.includes("[")
                                ? JSON.parse(client.attachment)
                                : client.attachment.split(",");

                              const firstImage = attachments[0];

                              return (
                                <div
                                  className="cursor-pointer"
                                  onClick={() => openAttachmentModal(attachments)}
                                >
                                  <img
                                    src={`${base_url}/${firstImage}`}
                                    alt={client.name}
                                    className="h-10 w-10 rounded object-cover border"
                                  />
                                </div>
                              );
                            })() : (
                              <div className="h-10 w-10 rounded bg-gray-200 flex items-center justify-center">
                                <span className="text-xs text-gray-500">No attachment</span>
                              </div>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {client.payment_date ? new Date(client.payment_date).toLocaleDateString() : "-"}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{client.name}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{client.company}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{client.email}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{client.phone}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {client.website && (
                              <a href={client.website} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                {client.website}
                              </a>
                            )}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap">
                            <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${client.status === 'active' ? 'bg-green-100 text-green-800' : client.status === 'inactive' ? 'bg-red-100 text-red-800' : 'bg-yellow-100 text-yellow-800'}`}> {client.status || 'lead'} </span>
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{client.source}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {client.plan_id ? (() => {
                              const plan = plans.find(p => p.id == client.plan_id);
                              return plan ? `${plan.name} (${plan.duration})` : "-";
                            })() : "-"}
                          </td>

                          
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {new Date(client.created_at).toLocaleDateString()}
                          </td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            {client.assigned_employee ? (
                              <div className="flex items-center">
                                {client.assigned_employee.profile_picture ? (
                                  <img
                                    src={`${base_url}/${client.assigned_employee.profile_picture}`}
                                    alt={client.assigned_employee.name}
                                    className="h-8 w-8 rounded-full mr-2 object-cover"
                                  />
                                ) : (
                                  <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center mr-2">
                                    <FiUser size={14} className="text-gray-500" />
                                  </div>
                                )}
                                <span>{client.assigned_employee.name}</span>
                              </div>
                            ) : (
                              <span className="text-gray-400">Unassigned</span>
                            )}
                          </td>
                          
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {(!clients || clients.length === 0) && (
                    <div className="text-center py-8 text-gray-500">No clients found</div>
                  )}
                </div>

                {/* Edit Client Modal */}
                {editingClient && (
                  <EditClientModal
                    client={editingClient}
                    onClose={() => setEditingClient(null)}
                    onSave={handleUpdateClient}
                    base_url={base_url}
                    plans={plans}
                  />
                )}
              </div>
            )}
            
            {activePage === 'campaigns' && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h2 className="text-xl font-semibold mb-4">Campaigns</h2>
                
                {/* Simplified Add Campaign Form - Only client_id and status */}
                {/* <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6">
                  <select
                    value={newCampaign.client_id}
                    onChange={(e) => setNewCampaign({ ...newCampaign, client_id: e.target.value })}
                    className="px-3 py-2 border rounded-lg"
                    required
                  >
                    <option value="">Select Client</option>
                    {Array.isArray(clients) && clients.map(c => (
                      <option key={c.id} value={c.id}>{c.name} - {c.company}</option>
                    ))}
                  </select>

                  <select
                    value={newCampaign.status}
                    onChange={(e) => setNewCampaign({ ...newCampaign, status: e.target.value })}
                    className="px-3 py-2 border rounded-lg"
                  >
                    <option value="draft">Draft</option>
                    <option value="active">Active</option>
                    <option value="paused">Paused</option>
                    <option value="completed">Completed</option>
                    <option value="cancelled">Cancelled</option>
                  </select>

                  <button
                    onClick={addCampaign}
                    className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700"
                  >
                    Add Campaign
                  </button>
                </div> */}

                {/* Campaigns Table with Full Client Details */}
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                          <input
                            type="checkbox"
                            onChange={(e) => handleSelectAllCampaigns(e.target.checked)}
                            checked={selectedCampaigns.length === campaigns.length && campaigns.length > 0}
                            className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                          />
                        </th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Date</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign Status</th>
                        {/* <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th> */}
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Campaign ID</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Client Logo</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Client Images</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Client Name</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Company</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Email</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Phone</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Website</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Client Status</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Source</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plan</th>
                        
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Assigned Employee</th>
                        
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {(Array.isArray(campaigns) ? campaigns : []).map((campaign) => {
                        return (
                          <tr key={campaign.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap">
                              <input
                                type="checkbox"
                                checked={selectedCampaigns.includes(campaign.id)}
                                onChange={(e) => handleCampaignSelect(campaign.id, e.target.checked)}
                                className="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                              />
                            </td>
                            {/* Actions */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <button
                                onClick={() => {
                                  setSelectedClientForAssignment({ id: campaign.client_id, ...campaign });
                                  setShowEmployeeModal(true);
                                }}
                                className="text-purple-600 hover:text-purple-900 mr-3"
                                title="Assign Employee"
                              >
                                <FiUserPlus size={18} />
                              </button>
                              <button
                                onClick={() => {
                                  setSelectedCampaignForWhatsApp(campaign);
                                  setShowWhatsAppSender(true);
                                }}
                                className="text-green-600 hover:text-green-900 mr-3"
                                title="Send via WhatsApp"
                              >
                                <FiMessageCircle size={18} />
                              </button>
                              <button
                                onClick={() => handleDeleteCampaign(campaign.id)}
                                className="text-red-600 hover:text-red-900"
                              >
                                Delete
                              </button>
                            </td>
                            {/* Payment Date */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.payment_date ? new Date(campaign.payment_date).toLocaleDateString() : "-"}
                            </td>

                            {/* Campaign Status - UPDATABLE */}
                            <td className="px-6 py-4 whitespace-nowrap">
                              <select
                                value={campaign.status || 'draft'}
                                onChange={(e) => handleCampaignStatusChange(campaign.id, e.target.value)}
                                className={`px-2 py-1 text-xs font-semibold rounded-full border-0 cursor-pointer
                                  ${campaign.status === 'active' ? 'bg-green-100 text-green-800' : 
                                    campaign.status === 'paused' ? 'bg-yellow-100 text-yellow-800' : 
                                    campaign.status === 'completed' ? 'bg-blue-100 text-blue-800' : 
                                    campaign.status === 'cancelled' ? 'bg-red-100 text-red-800' : 
                                    'bg-gray-100 text-gray-800'}`}
                              >
                                <option value="draft">Draft</option>
                                <option value="active">Active</option>
                                <option value="paused">Paused</option>
                                <option value="completed">Completed</option>
                                <option value="cancelled">Cancelled</option>
                              </select>
                            </td>
                            {/* <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{campaign.id}</td> */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">CAMP-{campaign.id}</td>
                            
                            {/* Client Logo */}
                            <td className="px-6 py-4 whitespace-nowrap">
                              {campaign.client_logo ? (
                                <img src={`${base_url}/${campaign.client_logo}`} alt={campaign.client_name} className="h-10 w-10 rounded-full object-cover" />
                              ) : (
                                <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                                  <span className="text-xs text-gray-500">No logo</span>
                                </div>
                              )}
                            </td>

                            {/* Client Images */}
                            <td className="px-6 py-4 whitespace-nowrap">
                              {campaign.client_attachment ? (() => {
                                const attachments = campaign.client_attachment.includes("[")
                                  ? JSON.parse(campaign.client_attachment)
                                  : campaign.client_attachment.split(",");

                                const firstImage = attachments[0];

                                return (
                                  <div
                                    className="cursor-pointer"
                                    onClick={() => openAttachmentModal(attachments)}
                                  >
                                    <img
                                      src={`${base_url}/${firstImage}`}
                                      alt={campaign.client_name}
                                      className="h-10 w-10 rounded object-cover border"
                                    />
                                  </div>
                                );
                              })() : (
                                <div className="h-10 w-10 rounded bg-gray-200 flex items-center justify-center">
                                  <span className="text-xs text-gray-500">No attachment</span>
                                </div>
                              )}
                            </td>

                            {/* Client Details */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                              {campaign.client_name || 'N/A'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.client_company || 'N/A'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.client_email || 'N/A'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.client_phone || 'N/A'}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.client_website && (
                                <a href={campaign.client_website} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                                  {campaign.client_website}
                                </a>
                              )}
                            </td>

                            {/* Client Status */}
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-2 inline-flex text-xs leading-5 font-semibold rounded-full ${
                                campaign.client_status === 'active' ? 'bg-green-100 text-green-800' : 
                                campaign.client_status === 'inactive' ? 'bg-red-100 text-red-800' : 
                                'bg-yellow-100 text-yellow-800'
                              }`}>
                                {campaign.client_status || 'lead'}
                              </span>
                            </td>

                            {/* Source */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.client_source || 'N/A'}
                            </td>

                            {/* Plan */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.plan_id ? (() => {
                                const plan = plans.find(p => p.id == campaign.plan_id);
                                return plan ? `${plan.name} (${plan.duration})` : "-";
                              })() : "-"}
                            </td>

                            

                            {/* Created Date */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {new Date(campaign.created_at).toLocaleDateString()}
                            </td>

                            {/* Assigned Employee */}
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {campaign.assigned_employee_data ? (
                                <div className="flex items-center">
                                  {campaign.assigned_employee_data.profile_picture ? (
                                    <img
                                      src={`${base_url}/${campaign.assigned_employee_data.profile_picture}`}
                                      alt={campaign.assigned_employee_data.name}
                                      className="h-8 w-8 rounded-full mr-2 object-cover"
                                    />
                                  ) : (
                                    <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center mr-2">
                                      <FiUser size={14} className="text-gray-500" />
                                    </div>
                                  )}
                                  <span>{campaign.assigned_employee_data.name}</span>
                                </div>
                              ) : (
                                <span className="text-gray-400">Unassigned</span>
                              )}
                            </td>

                            
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  {(!campaigns || campaigns.length === 0) && (
                    <div className="text-center py-8 text-gray-500">No campaigns found</div>
                  )}
                </div>
              </div>
            )}
            
            {/* Employees Section */}
            {activePage === 'employees' && (
              <div className="flex gap-6">
                {/* Main Employee Management Section */}
                <div className="flex-1 bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                  <h2 className="text-xl font-semibold mb-4">Manage Employees</h2>

                  {/* Add Employee Form */}
                  <div className="flex flex-col sm:flex-row gap-4 mb-6">
                    <input
                      value={newEmployee}
                      onChange={e => setNewEmployee(e.target.value)}
                      placeholder="Enter employee name"
                      className="flex-1 px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                    />
                    <button
                      onClick={addEmployee}
                      className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-2 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all flex items-center justify-center gap-2"
                    >
                      <FiPlus />
                      Add Employee
                    </button>
                  </div>

                  {/* Employees Table */}
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Profile</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Code</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Role</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {employees.map(emp => (
                          <tr key={emp.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{emp.id}</td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              {emp.profile_picture ? (
                                <img
                                  src={`${base_url}/${emp.profile_picture}`}
                                  alt={emp.name}
                                  className="h-10 w-10 rounded-full object-cover"
                                />
                              ) : (
                                <div className="h-10 w-10 rounded-full bg-gray-200 flex items-center justify-center">
                                  <FiUser size={20} className="text-gray-500" />
                                </div>
                              )}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{emp.name}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{emp.code || 'N/A'}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{emp.role || 'Employee'}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <button
                                onClick={() => openEditEmployeeModal(emp)}
                                className="text-blue-600 hover:text-blue-900 mr-3"
                              >
                                Edit
                              </button>
                              <button
                                onClick={() => handleDeleteEmployee(emp.id)}
                                className="text-red-600 hover:text-red-900"
                              >
                                Delete
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    {employees.length === 0 && (
                      <div className="text-center py-8 text-gray-500">No employees found</div>
                    )}
                  </div>
                </div>                
              </div>
            )}
            {activePage === 'payroll' && (
              <div className="space-y-6">
                {/* Payroll Header */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  <h2 className="text-2xl font-bold text-gray-800">Payroll Management</h2>
                  <div className="flex gap-3">
                    <button
                      onClick={() => {
                        const month = prompt('Enter month (YYYY-MM):', new Date().toISOString().slice(0, 7));
                        if (month) generatePayrollReport(month);
                      }}
                      className="bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-lg font-medium hover:from-purple-700 hover:to-pink-700 transition-all flex items-center gap-2"
                    >
                      <FiDownloadCloud />
                      Generate Report
                    </button>
                    <button
                      onClick={() => setShowAddSalary(true)}
                      className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center gap-2"
                    >
                      <FiPlus />
                      Add Salary
                    </button>
                  </div>
                </div>

                {/* Salary Stats */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Total Salary Records</p>
                    <p className="text-2xl font-bold text-gray-800">{salaries.length}</p>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Total Paid Amount</p>
                    <p className="text-2xl font-bold text-green-600">
                      ₹{salaries.filter(s => s.status === 'paid').reduce((sum, s) => sum + parseFloat(s.net_salary), 0).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Pending Payments</p>
                    <p className="text-2xl font-bold text-yellow-600">
                      ₹{salaries.filter(s => s.status === 'pending').reduce((sum, s) => sum + parseFloat(s.net_salary), 0).toLocaleString()}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">This Month's Payroll</p>
                    <p className="text-2xl font-bold text-blue-600">
                      ₹{salaries.filter(s => s.salary_month === new Date().toISOString().slice(0, 7)).reduce((sum, s) => sum + parseFloat(s.net_salary), 0).toLocaleString()}
                    </p>
                  </div>
                </div>

                {/* Salaries Table */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Employee</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Month</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Base Salary</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Allowances</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Bonus</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Deductions</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Net Salary</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Payment Date</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {salaries.map(salary => {
                          const employee = employees.find(e => e.id == salary.employee_id);
                          return (
                            <tr key={salary.id} className="hover:bg-gray-50">
                              <td className="px-6 py-4 whitespace-nowrap">
                                <div className="flex items-center">
                                  {employee?.profile_picture ? (
                                    <img src={`${base_url}/${employee.profile_picture}`} alt="" className="h-8 w-8 rounded-full mr-3 object-cover" />
                                  ) : (
                                    <div className="h-8 w-8 rounded-full bg-gray-200 flex items-center justify-center mr-3">
                                      <FiUser size={14} className="text-gray-500" />
                                    </div>
                                  )}
                                  <div>
                                    <p className="text-sm font-medium text-gray-900">{employee?.name || 'Unknown'}</p>
                                    <p className="text-xs text-gray-500">{employee?.code || 'No code'}</p>
                                  </div>
                                </div>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {new Date(salary.salary_month + '-01').toLocaleDateString('default', { month: 'long', year: 'numeric' })}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                ₹{parseFloat(salary.base_salary).toLocaleString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600">
                                +₹{parseFloat(salary.allowances).toLocaleString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-blue-600">
                                +₹{parseFloat(salary.bonus).toLocaleString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-red-600">
                                -₹{parseFloat(salary.deductions).toLocaleString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-bold text-gray-900">
                                ₹{parseFloat(salary.net_salary).toLocaleString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {new Date(salary.payment_date).toLocaleDateString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 py-1 text-xs rounded-full ${getSalaryStatusColor(salary.status)}`}>
                                  {salary.status}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                <button
                                  onClick={() => {
                                    setSelectedSalary(salary);
                                    setShowSalaryDetails(true);
                                  }}
                                  className="text-blue-600 hover:text-blue-900 mr-3"
                                >
                                  <FiEye size={18} />
                                </button>
                                {salary.status === 'pending' && (
                                  <button
                                    onClick={() => handleUpdateSalaryStatus(salary.id, 'paid')}
                                    className="text-green-600 hover:text-green-900 mr-3"
                                  >
                                    <FiCheckCircle size={18} />
                                  </button>
                                )}
                                <button
                                  onClick={() => handleDeleteSalary(salary.id)}
                                  className="text-red-600 hover:text-red-900"
                                >
                                  <FiTrash2 size={18} />
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                        {salaries.length === 0 && (
                          <tr>
                            <td colSpan="10" className="px-6 py-8 text-center text-gray-500">
                              No salary records found. Create your first salary record!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Add Salary Modal */}
                <AddSalaryModal
                  show={showAddSalary}
                  onClose={() => {
                    setShowAddSalary(false);
                    resetSalaryForm();
                  }}
                  employees={employees}
                />

                {/* Salary Details Modal */}
                <SalaryDetailsModal
                  show={showSalaryDetails}
                  onClose={() => {
                    setShowSalaryDetails(false);
                    setSelectedSalary(null);
                  }}
                  salary={selectedSalary}
                  employees={employees}
                />
              </div>
            )}
            {/* Invoices Section */}
            {activePage === 'invoices' && (
              <div className="space-y-6">
                {/* Invoices Header */}
                {/* <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  <h2 className="text-2xl font-bold text-gray-800">Invoice Management</h2>
                  <button
                    onClick={() => {
                      setSelectedLeadForConversion(null);
                      setConversionForm({
                        name: "",
                        company: "",
                        email: "",
                        phone: "",
                        website: "",
                        address: "",
                        plan_id: "",
                        payment_date: ""
                      });
                      setShowConvertLeadModal(true);
                    }}
                    className="bg-gradient-to-r from-blue-600 to-indigo-600 px-4 py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center gap-2"
                  >
                    <FiPlus />
                    Create Invoice
                  </button>
                </div> */}

                {/* Invoice Stats */}
                <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4">
                  {['draft', 'sent', 'paid', 'overdue', 'cancelled'].map(status => (
                    <div key={status} className="bg-white rounded-lg shadow-sm border border-gray-200 p-3">
                      <p className="text-xs text-gray-500 capitalize">{status}</p>
                      <p className="text-xl font-bold text-gray-800">
                        {invoices.filter(i => i.status === status).length}
                      </p>
                    </div>
                  ))}
                </div>

                {/* Invoices Table */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Invoice #</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Client</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Date</th>                          
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Amount</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {invoices.map(invoice => {
                          const client = clients.find(c => c.id == invoice.client_id);
                          return (
                            <tr key={invoice.id} className="hover:bg-gray-50">
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                {invoice.invoice_no}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {client?.name || 'Unknown'}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                {new Date(invoice.payment_date).toLocaleDateString()}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                                ₹{parseFloat(invoice.total_amount).toFixed(2)}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap">
                                <span className={`px-2 py-1 text-xs rounded-full ${getInvoiceStatusColor(invoice.status)}`}>
                                  {invoice.status}
                                </span>
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                                <button
                                  onClick={() => {
                                    fetchInvoiceItems(invoice.file_path);
                                  }}
                                  className="text-blue-600 hover:text-blue-900 mr-3"
                                >
                                  View
                                </button>
                                <button
                                  onClick={() => handleDeleteInvoice(invoice.id)}
                                  className="text-red-600 hover:text-red-900"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          );
                        })}
                        {invoices.length === 0 && (
                          <tr>
                            <td colSpan="7" className="px-6 py-8 text-center text-gray-500">
                              No invoices found. Create your first invoice!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Add Invoice Modal */}
                <AddInvoiceModal
                  show={showAddInvoice}
                  onClose={() => setShowAddInvoice(false)}
                  clients={clients}
                />

                {/* Invoice Details Modal */}
                <InvoiceDetailsModal
                  show={showInvoiceDetails}
                  onClose={() => {
                    setShowInvoiceDetails(false);
                    setSelectedInvoice(null);
                    setInvoiceItems([]);
                  }}
                  invoice={selectedInvoice}
                  items={invoiceItems}
                  clients={clients}
                  onStatusUpdate={handleUpdateInvoiceStatus}
                />
              </div>
            )}
            
            {/* Projects Section */}
            {activePage === 'projects' && (
              <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6">
                <h2 className="text-xl font-semibold mb-4">Manage Projects</h2>

                {/* Add Project Form */}
                <div className="flex flex-col sm:flex-row gap-4 mb-6">
                  <input
                    value={newProject}
                    onChange={e => setNewProject(e.target.value)}
                    placeholder="Enter project name"
                    className="flex-1 px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  />
                  <button
                    onClick={addProject}
                    className="bg-gradient-to-r from-green-600 to-emerald-600 text-white px-6 py-2 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700 transition-all flex items-center justify-center gap-2"
                  >
                    <FiPlus />
                    Add Project
                  </button>
                </div>

                {/* Projects Table */}
                <div className="overflow-x-auto">
                  <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                      <tr>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Name</th>
                        <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                      </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                      {projects.map(pro => (
                        <tr key={pro.id} className="hover:bg-gray-50">
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{pro.id}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{pro.name}</td>
                          <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                            <button className="text-blue-600 hover:text-blue-900 mr-3">Edit</button>
                            <button className="text-red-600 hover:text-red-900">Delete</button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  {projects.length === 0 && (
                    <div className="text-center py-8 text-gray-500">No projects found</div>
                  )}
                </div>
              </div>
            )}
            {/* Plans Section */}
            {activePage === 'plans' && (
              <div className="space-y-6">
                {/* Plans Header */}
                <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
                  <h2 className="text-2xl font-bold text-gray-800">Plan Management</h2>
                  <button
                    onClick={openAddPlanModal}
                    className="bg-gradient-to-r from-blue-600 to-indigo-600 text-white px-4 py-2 rounded-lg font-medium hover:from-blue-700 hover:to-indigo-700 transition-all flex items-center gap-2"
                  >
                    <FiPlus />
                    Add Plan
                  </button>
                </div>

                {/* Plan Stats */}
                <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Total Plans</p>
                    <p className="text-2xl font-bold text-gray-800">{plans.length}</p>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Active Plans</p>
                    <p className="text-2xl font-bold text-green-600">
                      {plans.filter(p => p.status === 'active').length}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Monthly Plans</p>
                    <p className="text-2xl font-bold text-blue-600">
                      {plans.filter(p => p.duration === 'monthly').length}
                    </p>
                  </div>
                  <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4">
                    <p className="text-sm text-gray-500">Yearly Plans</p>
                    <p className="text-2xl font-bold text-purple-600">
                      {plans.filter(p => p.duration === 'yearly').length}
                    </p>
                  </div>
                </div>

                {/* Plans Table */}
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                  <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">ID</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Plan Name</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Price</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Duration</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Status</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Created Date</th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">Actions</th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {plans.map((plan) => (
                          <tr key={plan.id} className="hover:bg-gray-50">
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{plan.id}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{plan.name}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              ₹{parseFloat(plan.price).toLocaleString()}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-2 py-1 text-xs rounded-full ${
                                plan.duration === 'monthly' ? 'bg-blue-100 text-blue-800' :
                                plan.duration === 'half-yearly' ? 'bg-yellow-100 text-yellow-800' :
                                'bg-green-100 text-green-800'
                              }`}>
                                {plan.duration}
                              </span>
                            </td>
                            
                            <td className="px-6 py-4 whitespace-nowrap">
                              <span className={`px-2 py-1 text-xs rounded-full ${
                                plan.status === 'active' ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'
                              }`}>
                                {plan.status}
                              </span>
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              {new Date(plan.created_at).toLocaleDateString()}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">
                              <button
                                onClick={() => openEditPlanModal(plan)}
                                className="text-blue-600 hover:text-blue-900 mr-3"
                              >
                                <FiEdit2 size={18} />
                              </button>
                              <button
                                onClick={() => deletePlan(plan.id)}
                                className="text-red-600 hover:text-red-900"
                              >
                                <FiTrash2 size={18} />
                              </button>
                            </td>
                          </tr>
                        ))}
                        {plans.length === 0 && (
                          <tr>
                            <td colSpan="8" className="px-6 py-8 text-center text-gray-500">
                              No plans found. Create your first plan!
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Plan Modal */}
                <PlanModal
                  show={showPlanModal}
                  onClose={() => {
                    setShowPlanModal(false);
                    setEditingPlan(null);
                    resetPlanForm();
                  }}
                  onSave={editingPlan ? updatePlan : addPlan}
                  editingPlan={editingPlan}
                  planForm={planForm}
                  setPlanForm={setPlanForm}
                />
              </div>
            )}
            {/* Settings Section */}
            {/* {activePage === 'settings' && (
              <div className="max-w-4xl mx-auto">
                <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6">
                  <h2 className="text-xl font-semibold text-gray-800 mb-6">Settings</h2>
                  <p className="text-gray-500">Settings panel coming soon...</p>
                </div>
              </div>
            )} */}
          </div>
        </main>
      </div>
      {/* Convert Lead to Client Modal (for admin section) */}
      {showConvertLeadModal && selectedLeadForConversion && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4">
          <div className="bg-white rounded-xl shadow-xl max-w-md w-full max-h-[90vh] flex flex-col">
            {/* Fixed Header */}
            <div className="p-6 pb-2 flex-shrink-0">
              <h3 className="text-xl font-bold text-gray-800 mb-2">Convert Lead to Client</h3>
              <p className="text-sm text-gray-600">
                Lead: <span className="font-medium">{selectedLeadForConversion.name}</span>
              </p>
            </div>

            {/* Scrollable Content */}
            <div className="overflow-y-auto px-6 flex-1">
              <div className="space-y-4 pb-4">
                <input
                  type="text"
                  placeholder="Client Name *"
                  value={conversionForm.name}
                  onChange={e => setConversionForm({ ...conversionForm, name: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <input
                  type="text"
                  placeholder="Company"
                  value={conversionForm.company}
                  onChange={e => setConversionForm({ ...conversionForm, company: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <input
                  type="email"
                  placeholder="Email"
                  value={conversionForm.email}
                  onChange={e => setConversionForm({ ...conversionForm, email: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <input
                  type="tel"
                  placeholder="Phone"
                  value={conversionForm.phone}
                  onChange={e => setConversionForm({ ...conversionForm, phone: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <input
                  type="text"
                  placeholder="Website"
                  value={conversionForm.website}
                  onChange={e => setConversionForm({ ...conversionForm, website: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                />
                <textarea
                  placeholder="Address"
                  value={conversionForm.address}
                  onChange={e => setConversionForm({ ...conversionForm, address: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                  rows="2"
                />

                {/* Plan Selection */}
                <select
                  value={conversionForm.plan_id}
                  onChange={e => setConversionForm({ ...conversionForm, plan_id: e.target.value })}
                  className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                >
                  <option value="">Select Plan</option>
                  {plans.map(plan => (
                    <option key={plan.id} value={plan.id}>
                      {plan.name} - ₹{plan.price} ({plan.duration})
                    </option>
                  ))}
                </select>

                {/* Payment Date */}
                <div>
                  <label className="block text-sm text-gray-600 mb-1">Payment Date</label>
                  <input
                    type="date"
                    value={conversionForm.payment_date}
                    onChange={e => setConversionForm({ ...conversionForm, payment_date: e.target.value })}
                    className="w-full px-4 py-2 border border-gray-200 rounded-lg focus:ring-2 focus:ring-green-500"
                  />
                </div>
                
                {/* Checkbox for Invoice */}
                <div className="flex items-center gap-3 py-2">
                  <input
                    type="checkbox"
                    id="createInvoice"
                    checked={conversionForm.create_invoice || false}
                    onChange={(e) => setConversionForm({ ...conversionForm, create_invoice: e.target.checked })}
                    className="w-4 h-4 text-green-600 border-gray-300 rounded focus:ring-green-500"
                  />
                  <label htmlFor="createInvoice" className="text-sm font-medium text-gray-700">
                    Create Invoice
                  </label>
                </div>
              </div>
            </div>

            {/* Fixed Footer with Buttons */}
            <div className="p-6 pt-4 border-t border-gray-100 flex-shrink-0">
              <div className="flex gap-3">
                <button
                  onClick={convertLeadToClient}
                  className="flex-1 bg-gradient-to-r from-green-600 to-emerald-600 text-white py-2 rounded-lg font-medium hover:from-green-700 hover:to-emerald-700"
                >
                  Convert to Client
                </button>
                <button
                  onClick={() => {
                    setShowConvertLeadModal(false);
                    setSelectedLeadForConversion(null);
                    setConversionForm({
                      name: "",
                      company: "",
                      email: "",
                      phone: "",
                      website: "",
                      address: "",
                      plan_id: "",
                      payment_date: "",
                      create_invoice: false
                    });
                  }}
                  className="flex-1 bg-gray-100 text-gray-600 py-2 rounded-lg font-medium hover:bg-gray-200"
                >
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default App;